import React, { ChangeEvent, useEffect, useMemo, useRef, useState } from 'react';
import { AnyIfEmpty, useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {
    colourStyles,
    defaultOfficeHours,
    errorsObj,
    exceptThisSymbols,
    propertiesToDelete,
    ReportSendTimes,
    SelectedLockers,
    selecteStates,
    statusEnum,
    TimeZones,
    validateTabs,
} from '../../../constants/constants';
import * as XLSX from 'xlsx';
import { FileDetails, isValidHttpUrl } from '../../../utils/utils';
import Loader from '../../common/loader/Loader';
import OTPInput from '../../common/otp-input/OtpInput';
import Toast from '../../common/toast/Toast';
import GoogleAutocompleteInput from '../../autocomplete/AutoComplete';
import ExperienceMessage from '../experience/ExperienceMessage';
import {
    addLocationObj,
    MessageData,
    PmsConfig,
    PmsConfigArray,
    PmsConfigData,
    Rest,
    SelectProps,
    TimeProps,
} from '../interfaces/locations.interface';
import {
    EntrataFormState,
    KnockFormState,
    RealpageFormState,
    ResmanFormState,
    PmsConfigSaveData,
    YardiFormState,
} from './PMSConfiguration/type';
import {
    addLocation,
    addTime,
    editLocation,
    FileState,
    getLocationById,
    getOfficeHourLogs,
    getTime,
    resetErrorMessage,
} from '../../../redux/location/actions/location.action';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';

import { uploadFile, uploadImages } from '../../../redux/staff/actions/staff.action';
import { bytesToMB } from '../Locations';

import iconClosePreview from '../../../images/icon-close-preview.svg';
import iconUpload from '../../../images/icon-upload-unit.svg';
import hideAccordion from '../../../images/iconHideAccordion.svg';
import backArrow from '../../../images/icons-back-arrow.svg';
import showAccordion from '../../../images/iconShowAccordion.svg';
import ExcelIcon from '../../svgIcons/ExcelIcon';
import xlsIcon from '../../../images/xls-icon.svg';
import iconClose from '../../../images/icon-close.svg';
import EyeIcon from '../../svgIcons/EyeIcon';

import 'react-phone-input-2/lib/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-tabs/style/react-tabs.css';
import styles from './AddProperty.module.css';

import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import 'quill/dist/quill.snow.css';
import { DeltaStatic, Sources } from 'quill';

import MapIconv2 from '../../svgIcons/MapIconV2';
import PDFIcon from '../../svgIcons/PDFIcon';
import ImageIcon from '../../svgIcons/ImageIcon';
import HistoryIcon from '../../svgIcons/HistoryIcon';
import CustModal from '../../common/custmodal/CustModal';
import HistoryModalBody from './HistoryModalBody';
import PropertyInformationModalBody from './PropertyInformationModalBody';
import MapView from '../../mapview/MapView';
import { hasPermission } from '../../auth/login/Login';
import { getLockerTypes } from '../../../redux/locker-version/action/locker-version.actions';
import PMSConfiguaration from './PMSConfiguration/PMSConfiguaration';
import Button from '../../common/button/Button';
import RealPagePMSIcon from '../../svgIcons/RealPagePMSIcon';
import KnockPMSIcon from '../../svgIcons/KnowkPmsIcon';
import YardiPMSIcon from '../../svgIcons/YardiPMSIcon';
import ResmanPMSIcon from '../../svgIcons/ResmanPMSIcon';
import EntrataPMSIcon from '../../svgIcons/EntrataPMSIcon';
import FunnelPMSIcon from '../../svgIcons/FunnelPMSIcon';

const AddProperty = ({}) => {
    const userInfo = JSON.parse(localStorage.getItem('user') || '{}');
    const { loading: locationDetailLoading, data: locationDetail } = useSelector((state: IRootState) => state.locationReducer.location);
    const { loading: officeHoursLoading, data: officeHourData } = useSelector((state: IRootState) => state.locationReducer.officeHoursLogs);
    const { data: lockerData } = useSelector((state: IRootState) => state.lockerTypeReducer);
    const canUpdatePMSInfo = hasPermission('Staff Management', 'PMS information', 'create');
    const canUpdateErrorNotification = hasPermission('Staff Management', 'Error Notification', 'create');
    const canUpdateChatbotInsights = hasPermission('Staff Management', 'Insights Chatbot', 'create');
    const locationID = useParams();
    const pathName = window.location.pathname;
    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const time = useSelector((state: IRootState) => state.locationReducer.data.officeHours);
    const { loading: locationLoading, errorMsg: locationErrorMsg } = useSelector((state: IRootState) => state.locationReducer);
    const chatbotInsightsUpdateAccess = (userInfo && userInfo?.role === 'super_admin') || canUpdateChatbotInsights;
    const pmsInfoUpdateAccess = (userInfo && userInfo?.role === 'super_admin') || canUpdatePMSInfo;

    const [pmsConfigData, setPmsConfigData] = useState<PmsConfigSaveData | PmsConfigSaveData[] | PmsConfigArray | null>(null);
    const prevPathNameRef = useRef(pathName);
    useEffect(() => {
        if (pathName.includes('add-location')) {
            if (!prevPathNameRef.current.includes('add-location')) {
                setPmsConfigData(null);
            }
            prevPathNameRef.current = pathName;
            return;
        }
        prevPathNameRef.current = pathName;
        if (locationDetail?.location?.pmsConfig) {
            setPmsConfigData(locationDetail?.location?.pmsConfig as PmsConfigArray);
        }
    }, [pathName, locationDetail?.location?.pmsConfig]);

    const handlePmsConfigSave = (data: PmsConfigSaveData) => {
        const isCreate = pathName.includes('add-location');
        if (!isCreate) {
            setNewlyConnectedPmsEdit((prev) => {
                const idx = prev.findIndex((c) => c.pmsType === data.pmsType);
                return idx >= 0 ? prev.map((c, i) => (i === idx ? data : c)) : [...prev, data];
            });
            return;
        }
        setPmsConfigData((prev) => {
            const list: PmsConfigSaveData[] = !prev
                ? []
                : Array.isArray(prev)
                  ? (prev as unknown as PmsConfigSaveData[])
                  : [prev as PmsConfigSaveData];
            const isApiShape = list.length > 0 && 'pms_key' in (list[0] as unknown as Record<string, unknown>);
            if (isApiShape) return data;
            const idx = list.findIndex((c) => c.pmsType === data.pmsType);
            const next = idx >= 0 ? list.map((c, i) => (i === idx ? data : c)) : [...list, data];
            return next.length === 1 ? next[0] : next;
        });
    };

    useEffect(() => {
        if (locationErrorMsg && locationErrorMsg.length > 0) {
            setShowToast(true);
            setToastMessage(locationErrorMsg);

            setTimeout(() => {
                setShowToast(false);
                dispatch(resetErrorMessage());
            }, 4000);
        }
    }, [locationErrorMsg]);

    const [openModal, setOpenModal] = useState(false);
    const [editingPmsKey, setEditingPmsKey] = useState<string | null>(null);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [listOfPOI, setListOfPOI] = useState('');
    const [existingImages, setExistingImages] = useState([]);
    const [uploadFiles, setUploadFiles]: AnyIfEmpty<object> = useState([]);
    const [locationFiles, setLocationFiles] = useState({});
    const [videoFile, setVideoFile] = useState<FileState>({ file: null });
    const [otpValue, setOtpValue] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const canReadLogs = hasPermission('Audit log', 'Audit logs', 'read');
    const canCreateProperty = hasPermission('Properties & Units', 'Property', 'create');
    const canUpdateProperty = hasPermission('Properties & Units', 'Property', 'update');
    const [pmsConfigObject, setPmsConfigObject] = useState<any | null>(null);
    /** In edit mode: PMS connected in this session but not yet saved; shown in listing and disabled in Add PMS modal */
    const [newlyConnectedPmsEdit, setNewlyConnectedPmsEdit] = useState<PmsConfigSaveData[]>([]);
    /** In edit mode: PMS keys user deleted this session; excluded from pmsConfig on save */
    const [deletedPmsKeys, setDeletedPmsKeys] = useState<Set<string>>(new Set());
    const [showModal, setShowModal] = useState(false);
    const [phoneNumberLength, setPhoneNumberLength] = useState(11);
    const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
    const [showActionBox, setShowActionBox] = useState<string | null>(null);
    const [pmsKeyToDelete, setPmsKeyToDelete] = useState<string | null>(null);

    useEffect(() => {
        dispatch(getLockerTypes());
    }, []);

    interface Locker {
        id: string;
        lockerName: string;
    }

    const LockersVersion =
        lockerData?.map((locker: Locker) => ({
            value: locker.id,
            label: locker.lockerName,
        })) || [];

    useEffect(() => {
        if (
            (!canUpdateProperty && window?.location?.pathname?.includes('/edit-location') && locationID) ||
            (!locationID && !canCreateProperty)
        ) {
            navigate('/no-permission');
        }
        if (locationID.id && !pathName.includes('add-location') && canUpdateProperty) {
            dispatch(getLocationById(locationID?.id));
        }
    }, [locationID]);

    useEffect(() => {
        if (locationID && locationID?.id && (activeTab === 0 || activeTab === 3) && canReadLogs) {
            dispatch(getOfficeHourLogs(locationID?.id, activeTab));
        }
    }, [activeTab, locationID]);

    useEffect(() => {
        if (locationDetail.location && !pathName.includes('/add-location') && lockerData) {
            setAddLocationObj({
                description: locationDetail?.location?.description || '',
                name: locationDetail?.location?.name || '',
                street1: locationDetail?.location?.street1 || '',
                streetNumber: locationDetail?.location?.streetNumber || '',
                state: locationDetail?.location?.state || 'New York',
                city: locationDetail?.location?.city || '',
                zip: locationDetail?.location?.zip || '',
                masterCode: locationDetail?.location?.masterCode || '',
                images: locationDetail?.location?.images || [],
                videoUrl: locationDetail?.location?.videoUrl || '',
                confirmText: locationDetail?.location?.confirmText || '',
                mapUrl: locationDetail?.location?.mapUrl || '',
                openTime: locationDetail?.location?.openTime || '',
                closeTime: locationDetail?.location?.closeTime || '',
                appLink: locationDetail?.location?.appLink || '',
                contactLink: locationDetail?.location?.contactLink || '',
                beginningTourMessage: locationDetail?.location?.beginningTourMessage || '',
                endingTourMessage: locationDetail?.location?.endingTourMessage || '',
                email_caption: locationDetail?.location?.email_caption || '',
                yardiId: '',
                yardiUserName: '',
                yardiPassword: '',
                yardiServerName: '',
                yardiTransactionSource: '',
                yardiUrl: '',
                agentFirstName: '',
                agentLastName: '',
                funnelCommunityId: '',
                entrataUserName: '',
                entrataSubDomain: '',
                entrataPassword: '',
                entrataPropertyId: '',
                entrataUrl: '',
                buildingId: '',
                realPagePmcID: '',
                realPageSiteID: '',
                pineappleLeasingAgentID: '',
                realPageL2LPropertyId: '',
                realPageILMPropertyId: '',
                entrataOriginatingLeadSourceId: '',
                resmanTransactionSource: '',
                resmanAccountID: '',
                resmanAgentID: '',
                resmanPropertyID: '',
                knockCommunityId: '',
                knockAgentUserName: '',
                knockSourceTitle: '',
                knockCompanyId: '',
                knockPropertyId: '',
                realpageMarketingSourceId: '',
                isDocumentRequired:
                    locationDetail?.location?.isDocumentRequired !== undefined
                        ? locationDetail?.location?.isDocumentRequired == true
                            ? 'true'
                            : 'false'
                        : 'true',
                isCardRequired:
                    locationDetail?.location?.isCardRequired !== undefined
                        ? locationDetail?.location?.isCardRequired == true
                            ? 'true'
                            : 'false'
                        : 'true',
                propertyStatus: locationDetail?.location?.propertyStatus || 'Active',
                managementCompany: locationDetail?.location?.managementCompany || '',
                unitMapAssetId: locationDetail?.location?.unitMapAssetId || '',
                unitMapId: locationDetail?.location?.unitMapId || '',
                openViaChatBotPropertyId: locationDetail?.location?.openViaChatBotPropertyId
                    ? locationDetail?.location?.openViaChatBotPropertyId
                    : null,
                leasingAgentNumber: locationDetail?.location?.leasingAgentNumber
                    ? locationDetail?.location?.leasingAgentNumber?.toString()
                    : '',
                reportSendTime: locationDetail?.location?.reportSendTime || 'Monthly',
                isPriceListed:
                    locationDetail?.location?.isPriceListed !== undefined
                        ? locationDetail?.location.isPriceListed
                            ? 'true'
                            : 'false'
                        : 'true',
                // luxerBuildingId: locationDetail?.luxerBuildingId || '',
                leasingAgentEmailId: locationDetail?.location?.leasingAgentEmailId ? locationDetail?.location?.leasingAgentEmailId : '',
                propertyDetailsForBot: locationDetail?.location?.propertyDetailsForBot
                    ? locationDetail?.location?.propertyDetailsForBot
                    : null,
                showCardDisclaimer: locationDetail?.location?.showCardDisclaimer
                    ? Boolean(locationDetail?.location?.showCardDisclaimer).toString().toLowerCase() === 'true'
                        ? 'true'
                        : 'false'
                    : 'false',
                customCardDisclaimer: locationDetail?.location?.customCardDisclaimer
                    ? locationDetail?.location?.customCardDisclaimer.trim()
                    : null,
                mappedInId: locationDetail?.location?.mappedInId ? locationDetail?.location?.mappedInId : null,
                mapFilePath: locationDetail?.location?.mapFilePath ? locationDetail?.location?.mapFilePath : null,
                mappedInFloorId: locationDetail?.location?.mappedInFloorId ? locationDetail?.location?.mappedInFloorId : null,
                amazonKeyAccessId: locationDetail?.location?.amazonKeyAccessId ? locationDetail?.location?.amazonKeyAccessId : null,
                latitude: Number(locationDetail?.location?.latitude) || null,
                longitude: Number(locationDetail?.location?.longitude) || null,
                googlePlacesId: locationDetail?.location?.googlePlacesId || null,
                kioskAPIkey: locationDetail?.location?.kioskAPIkey || null,
                radius: Number(locationDetail?.location?.radius || 0),
                lockerName: locationDetail?.location?.lockerName
                    ? lockerData?.find((locker: any) => locationDetail?.location?.lockerName === locker?.id)?.id
                    : lockerData?.find((locker: any) => locker?.lockerName?.toLowerCase() === 'kiosk')?.id || '',
                errorNotification:
                    locationDetail?.location?.errorNotification !== null ? locationDetail?.location?.errorNotification : false,
            });

            if (locationDetail && locationDetail?.location?.masterCode) {
                setOtpValue(locationDetail?.location?.masterCode);
            }
            setSelectedOption(() => {
                return TimeZones.find((timeZone: SelectProps) => timeZone.value === locationDetail?.location?.timeZone);
            });
            setSelectedReportSendTime({ value: locationDetail?.location.reportSendTime, label: locationDetail?.location.reportSendTime });
            setSelectedLockers({ value: locationDetail?.location.lockersCount, label: locationDetail?.location.lockersCount });
            setListOfPOI(locationDetail?.location?.listOfPOI);
            setSelectedStatus({ value: locationDetail?.location.propertyStatus, label: locationDetail?.location.propertyStatus });
            setSelectedStates({ value: locationDetail?.location.state, label: locationDetail?.location.state });
            if (
                locationDetail.mapFileDetails &&
                Object(locationDetail.mapFileDetails) &&
                Object.entries(locationDetail.mapFileDetails).length > 0
            ) {
                setExistingMapFile({
                    name: locationDetail.mapFileDetails.fileName,
                    size: locationDetail.mapFileDetails.contentLength,
                    type: locationDetail.mapFileDetails.mimeType,
                });
                setShowMapFile(true);
            }
            setPmsConfigObject(locationDetail.location.pmsConfig);
            setIsOpenViaChecked(locationDetail?.location?.isOpenViaChecked);
            setNewlyConnectedPmsEdit([]);
            setDeletedPmsKeys(new Set());
        }
    }, [locationDetail, lockerData]);

    const [addLocationObj, setAddLocationObj] = useState<addLocationObj>({
        description: '',
        name: '',
        street1: '',
        streetNumber: '',
        state: 'New York',
        city: '',
        zip: '',
        masterCode: '',
        images: [],
        videoUrl: '',
        confirmText: '',
        mapUrl: '',
        openTime: '',
        closeTime: '',
        appLink: '',
        contactLink: '',
        beginningTourMessage: '',
        endingTourMessage: '',
        email_caption: '',
        yardiId: '',
        yardiUserName: '',
        yardiPassword: '',
        yardiServerName: '',
        yardiTransactionSource: '',
        yardiUrl: '',
        agentFirstName: '',
        agentLastName: '',
        funnelCommunityId: '',
        entrataUserName: '',
        entrataPassword: '',
        entrataSubDomain: '',
        entrataPropertyId: '',
        entrataUrl: '',
        buildingId: '',
        realPagePmcID: '',
        realPageSiteID: '',
        pineappleLeasingAgentID: '',
        realPageL2LPropertyId: '',
        realPageILMPropertyId: '',
        entrataOriginatingLeadSourceId: '',
        resmanTransactionSource: '',
        resmanAccountID: '',
        resmanAgentID: '',
        resmanPropertyID: '',
        knockCommunityId: '',
        knockAgentUserName: '',
        knockSourceTitle: '',
        knockCompanyId: '',
        knockPropertyId: '',
        realpageMarketingSourceId: '',
        isDocumentRequired: 'true',
        isCardRequired: 'true',
        propertyStatus: '',
        managementCompany: '',
        unitMapAssetId: '',
        unitMapId: '',
        openViaChatBotPropertyId: null,
        leasingAgentNumber: '',
        reportSendTime: 'Monthly',
        isPriceListed: 'true',
        leasingAgentEmailId: '',
        propertyDetailsForBot: null,
        showCardDisclaimer: '',
        customCardDisclaimer: null,
        mappedInId: null,
        mappedInFloorId: null,
        mapFilePath: null,
        amazonKeyAccessId: null,
        googlePlacesId: null,
        latitude: null,
        longitude: null,
        kioskAPIkey: null,
        radius: 0,
        lockerName: 'Kiosk',
        errorNotification: true,
    });

    const [excelFile, setExcelFile] = useState<FileState>({ file: null });
    const [mapFile, setMapFile] = useState<FileState>({ file: null });
    const [existingMapFile, setExistingMapFile] = useState<FileDetails | null>(null);
    const [excelError, setExcelError] = useState('');

    const [loading, setLoading] = useState(false);
    const [isTouched, setIstouched] = useState(false);
    const [message, setMessage] = useState<MessageData[]>([]);
    const [selectedOption, setSelectedOption] = useState(
        locationDetail && locationDetail?.location && !pathName.includes('add-location')
            ? TimeZones.find((timeZone: SelectProps) => timeZone.value === locationDetail?.location?.timeZone)
            : { value: 'America/New_York', label: 'Eastern Time' },
    );

    const [selectedReportSendTime, setSelectedReportSendTime] = useState(
        locationDetail && locationDetail?.location && !pathName.includes('add-location')
            ? ReportSendTimes.find((ReportSendTime: SelectProps) => ReportSendTime.value === locationDetail.location.reportSendTime)
            : { value: 'Monthly', label: 'Monthly' },
    );
    const [selectedStates, setSelectedStates] = useState(
        locationDetail && locationDetail?.location && !pathName.includes('add-location')
            ? selecteStates.find((state: SelectProps) => state.value === locationDetail.location.state)
            : { value: 'New York', label: 'New York' },
    );

    const [selectedLockers, setSelectedLockers] = useState(
        locationDetail && locationDetail?.location && !pathName.includes('add-location')
            ? SelectedLockers.find((locker) => locker.value === locationDetail?.location?.lockersCount)
            : { value: 10, label: 10 },
    );

    const [officeHours, setOfficeHours] = useState(defaultOfficeHours);
    const [oldOfficeHours, setOldOfficeHours] = useState(defaultOfficeHours);
    const [readOnly, setReadOnly] = useState(true);
    const [clicked, setClicked] = useState('-2');
    const yardiPmsEl = useRef<HTMLDivElement>(null);
    const EntrataPmsEl = useRef<HTMLDivElement>(null);
    const realPagePmsEl = useRef<HTMLDivElement>(null);
    const resManPmsEl = useRef<HTMLDivElement>(null);
    const funnelPmsEl = useRef<HTMLDivElement>(null);
    const [isOpenViaChecked, setIsOpenViaChecked] = useState(
        Boolean((locationDetail && !pathName.includes('add-location') && locationDetail?.location?.isOpenViaChecked) || false),
    );
    const [showMapFile, setShowMapFile] = useState(false);
    const [showLogsModal, setShowLogsModal] = useState(false);
    const [showPropertyInformationLogs, setShowPropertyInformationLogs] = useState(false);

    const [selectedStatus, setSelectedStatus] = useState(
        !pathName.includes('add-location') && locationDetail?.location?.propertyStatus
            ? statusEnum.find((status) => status.value === locationDetail?.location?.propertyStatus)
            : { value: 'Active', label: 'Active' },
    );

    const handleToggle = (index: string) => {
        if (clicked === index) {
            setClicked('-1');
        } else {
            setClicked(index);
        }
    };

    useEffect(() => {
        locationID && locationID?.id && !pathName.includes('add-location') && dispatch(getTime(locationID?.id));
    }, [locationID]);

    useEffect(() => {
        if (locationDetail && locationDetail?.location?.images?.length && !pathName.includes('add-location')) {
            setExistingImages(locationDetail?.location?.images);
        }
    }, [locationDetail]);

    useEffect(() => {
        if (pmsConfigObject) {
            pmsConfigObject?.forEach((pmsData: { pms_key: string; pms_config: PmsConfigData }) => {
                if (pmsData.pms_key === 'yardi') {
                    setAddLocationObj((prevState) => ({
                        ...prevState,
                        yardiId: pmsData?.pms_config?.yardiId,
                        yardiPassword: pmsData?.pms_config?.yardiPassword,
                        yardiServerName: pmsData?.pms_config?.yardiServerName,
                        yardiTransactionSource: pmsData?.pms_config?.yardiTransactionSource,
                        yardiUrl: pmsData?.pms_config?.yardiUrl,
                        yardiUserName: pmsData?.pms_config?.yardiUserName,
                        agentFirstName: pmsData?.pms_config?.agentFirstName || '',
                        agentLastName: pmsData?.pms_config?.agentLastName || '',
                    }));
                } else if (pmsData.pms_key === 'entrata') {
                    setAddLocationObj((prevState) => ({
                        ...prevState,
                        entrataPassword: pmsData?.pms_config?.entrataPassword,
                        entrataPropertyId: pmsData?.pms_config?.entrataPropertyId,
                        entrataUrl: pmsData?.pms_config?.entrataUrl,
                        entrataUserName: pmsData?.pms_config?.entrataUserName,
                        entrataOriginatingLeadSourceId: pmsData?.pms_config.entrataOriginatingLeadSourceId,
                        entrataSubDomain: pmsData?.pms_config?.entrataSubDomain,
                    }));
                } else if (pmsData.pms_key === 'realpage') {
                    setAddLocationObj((prevState) => ({
                        ...prevState,
                        buildingId: pmsData?.pms_config?.buildingId,
                        realPagePmcID: pmsData?.pms_config?.realPagePmcID,
                        realPageSiteID: pmsData?.pms_config?.realPageSiteID,
                        pineappleLeasingAgentID: pmsData?.pms_config?.pineappleLeasingAgentID,
                        realPageL2LPropertyId: pmsData?.pms_config?.realPageL2LPropertyId,
                        realPageILMPropertyId: pmsData?.pms_config?.realPageILMPropertyId,
                        realpageMarketingSourceId: pmsData.pms_config.realpageMarketingSourceId || '',
                    }));
                } else if (pmsData.pms_key === 'resman') {
                    setAddLocationObj((prevState) => ({
                        ...prevState,
                        resmanAccountID: pmsData.pms_config.resmanAccountID,
                        resmanPropertyID: pmsData.pms_config.resmanPropertyID,
                        resmanAgentID: pmsData.pms_config.resmanAgentID,
                        resmanTransactionSource: pmsData.pms_config.resmanTransactionSource,
                    }));
                } else if (pmsData.pms_key === 'knock') {
                    setAddLocationObj((prevState) => ({
                        ...prevState,
                        knockCommunityId: pmsData.pms_config.knockCommunityId,
                        knockAgentUserName: pmsData.pms_config.knockAgentUserName,
                        knockSourceTitle: pmsData?.pms_config?.knockSourceTitle || '',
                        knockCompanyId: pmsData?.pms_config?.knockCompanyId || '',
                        knockPropertyId: pmsData?.pms_config?.knockPropertyId || '',
                    }));
                } else if (pmsData.pms_key === 'funnel') {
                    setAddLocationObj((prevState) => ({
                        ...prevState,
                        funnelCommunityId: pmsData?.pms_config?.funnelCommunityId || '',
                    }));
                }
            });
        }
    }, [pmsConfigObject]);

    const uploadMapFile = async () => {
        setLoading(true);
        if (mapFile?.file) {
            let mapFilePath: Promise<string> = Promise.resolve('');
            await uploadFile(mapFile.file, 'maps')
                .then((result) => {
                    mapFilePath = Promise.resolve(result);
                })
                .catch((error) => {
                    console.error('Upload Map Error: ', error);
                });
            return mapFilePath;
        } else if (
            locationDetail.mapFileDetails &&
            locationDetail.mapFileDetails.fileName &&
            Boolean(locationDetail.mapFileDetails.fileName) &&
            Boolean(existingMapFile?.name)
        ) {
            return addLocationObj.mapFilePath || null;
        } else {
            return '';
        }
    };

    const handleFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];

        if (selectedFile) {
            if (selectedFile?.size > 5 * 1024 * 1024) {
                setToastMessage('File size exceeds 5 MB limit');
                setShowToast(true);
                setExcelFile({ file: null });
            } else if (
                !(
                    selectedFile?.type.toString() === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                    selectedFile?.type?.toString() === 'application/vnd.ms-excel' ||
                    selectedFile?.type?.toString() === 'application/vnd.oasis.opendocument.spreadsheet'
                )
            ) {
                setToastMessage('Please select .xls Or .xlsx file');
                setShowToast(true);
                setExcelFile({ file: null });
            } else {
                setExcelFile({ file: selectedFile });
                if (selectedFile) {
                    const reader = new FileReader();
                    reader.onload = (e: ProgressEvent<FileReader>) => {
                        const result = e.target?.result;
                        if (result) {
                            const data = new Uint8Array(result as ArrayBuffer);
                            const workbook = XLSX.read(data, { type: 'array' });

                            const firstSheetName = workbook.SheetNames[0];
                            const worksheet = workbook.Sheets[firstSheetName];
                            let isValid = true;
                            let formattedData = '';
                            let emptyRowCount = 0;

                            const jsonData = XLSX.utils.sheet_to_json<string[]>(worksheet, { header: 1 });

                            for (let index = 0; index < jsonData.length && isValid; index++) {
                                const row = jsonData[index];

                                if (row.length === 0) {
                                    emptyRowCount++;
                                    if (emptyRowCount >= 2) {
                                        isValid = false;
                                    }
                                } else {
                                    emptyRowCount = 0;
                                    if (index > 0 && row.length >= 2) {
                                        if (row[1] && row[1].toString().trim() !== '') {
                                            formattedData += `${
                                                row[0] && row[0].toString().trim() !== ''
                                                    ? 'Question:' + row[0].toString()?.trim() + '<br>'
                                                    : ''
                                            }Answer: ${row[1].toString().trim() || ''}<br><br>`;
                                        }
                                    }
                                }
                            }

                            if (formattedData.trim() !== '') {
                                setExcelError('');
                                setAddLocationObj((addLocationObj) => {
                                    return {
                                        ...addLocationObj,
                                        propertyDetailsForBot: formattedData,
                                    };
                                });
                            }
                        }
                    };
                    reader.readAsArrayBuffer(selectedFile);
                }
            }
        }
    };

    const handleMapFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];
        if (
            selectedFile?.type === 'image/jpeg' ||
            selectedFile?.type === 'image/jpg' ||
            selectedFile?.type === 'image/png' ||
            selectedFile?.type === 'image/webp' ||
            selectedFile?.type === 'application/pdf'
        ) {
            setMapFile({ file: selectedFile });
        } else {
            setShowToast(true);
            setToastMessage('Unsupported file type. Please upload a PDF or image file.');
        }
    };
    const handleVideoFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];

        if (!selectedFile) {
            return;
        }

        // Size validation
        if (selectedFile.size > 5 * 1024 * 1024) {
            setVideoFile({ file: null });
            setShowToast(true);
            setToastMessage('Video size exceeds 5 MB limit');
            return;
        }

        // Type validation
        if (selectedFile.type === 'video/mp4' || selectedFile.type === 'video/webm' || selectedFile.type === 'video/quicktime') {
            // Duration validation
            const video = document.createElement('video');

            video.preload = 'metadata';

            video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(video.src);

                if (video.duration > 120) {
                    setVideoFile({ file: null });
                    setShowToast(true);
                    setToastMessage('Video duration must be maximum 2 minutes');
                    return;
                }

                setVideoFile({ file: selectedFile });

                setAddLocationObj((prevState) => ({
                    ...prevState,
                    videoUrl: '',
                }));
            };
            video.src = URL.createObjectURL(selectedFile);
        } else {
            setShowToast(true);
            setToastMessage('Unsupported file type. Please upload an MP4, MOV, or WebM video.');
        }
    };
    useEffect(() => {
        if (time?.length > 0)
            if (time) {
                const temp: any = [];

                time &&
                    time.map((data: TimeProps) => {
                        temp.push({
                            id: data.id,
                            day: data.day,
                            openTime: data.openTime,
                            closeTime: data.closeTime,
                            isOpen: data.isOpen ? true : false,
                        });
                        const sorter: any = {
                            sunday: 0,
                            monday: 1,
                            tuesday: 2,
                            wednesday: 3,
                            thursday: 4,
                            friday: 5,
                            saturday: 6,
                        };

                        temp.sort(function sortByDay(a: TimeProps, b: TimeProps) {
                            const day1 = a.day.toLowerCase();
                            const day2 = b.day.toLowerCase();
                            return sorter[day1] - sorter[day2];
                        });
                    });

                setOfficeHours(temp);
                setOldOfficeHours(temp);
            }
    }, [time]);

    const closeModal = () => navigate(-1);

    useEffect(() => {
        setUploadFiles([...uploadFiles, ...Object.values(locationFiles)]);
    }, [locationFiles]);

    useEffect(() => {
        if (otpValue && otpValue?.length > 0) {
            setAddLocationObj((addLocationObj) => {
                return {
                    ...addLocationObj,
                    masterCode: otpValue,
                };
            });
        }
    }, [otpValue]);

    useEffect(() => {
        if (showToast) {
            setTimeout(() => {
                setShowToast(false);
            }, 4000);
        }
    }, [showToast]);

    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }],
        [{ size: ['small', false, 'large', 'huge'] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        ['clean'],
    ];

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, [activeTab]);

    useEffect(() => {
        if (locationID && locationID?.id && !pathName.includes('add-location') && !loading && !locationDetailLoading) {
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });
            }, 10);
        }
    }, [locationID, loading, locationDetailLoading]);

    const handleDeleteExistingImage = (fileIndex: number) => {
        const remainingImages = existingImages.filter((item: string, index: number) => index != fileIndex);
        setExistingImages(remainingImages);
    };

    const handleRemovePreview = (fileIndex: number) => {
        const remainingImages = uploadFiles.filter((item: string, index: number) => index != fileIndex);
        setUploadFiles(remainingImages);
    };

    const getLockerVersion = () => {
        if (lockerData && addLocationObj?.lockerName) {
            return lockerData?.find((locker: any) => addLocationObj?.lockerName === locker?.id)?.lockerName;
        } else {
            return null;
        }
    };


    type PmsType = "yardi" | "entrata" | "realpage" | "resman" | "knock" | "funnel";

    /** Empty pms_config object per pms_key for delete payload (backend recognizes and removes) */
    const getEmptyPmsConfigForDelete = (pms_key: string): Record<string, string> => {
        const empty = (keys: string[]) => keys.reduce((acc, k) => ({ ...acc, [k]: '' }), {} as Record<string, string>);
        switch (pms_key) {
            case 'yardi':
                return empty([
                    'yardiId',
                    'yardiUserName',
                    'yardiPassword',
                    'yardiServerName',
                    'yardiTransactionSource',
                    'yardiUrl',
                    'agentFirstName',
                    'agentLastName',
                ]);
            case 'entrata':
                return empty([
                    'entrataUserName',
                    'entrataPassword',
                    'entrataPropertyId',
                    'entrataSubDomain',
                    'entrataUrl',
                    'entrataOriginatingLeadSourceId',
                ]);
            case 'realpage':
                return empty([
                    'buildingId',
                    'realPagePmcID',
                    'realPageSiteID',
                    'pineappleLeasingAgentID',
                    'realPageL2LPropertyId',
                    'realPageILMPropertyId',
                    'realpageMarketingSourceId',
                ]);
            case 'resman':
                return empty(['resmanAccountID', 'resmanPropertyID', 'resmanAgentID', 'resmanTransactionSource']);
            case 'knock':
                return empty(['knockCommunityId', 'knockAgentUserName', 'knockSourceTitle', 'knockCompanyId', 'knockPropertyId']);
            case 'funnel':
                return empty(['funnelCommunityId']);
            default:
                return {};
        }
    };

    const buildPmsPayload = (data: PmsConfigSaveData | PmsConfigSaveData[] | PmsConfigArray | null | undefined): PmsConfigArray => {
        if (!data) return [];
        if (Array.isArray(data)) {
            if (data.length === 0) return [];
            const first = data[0] as unknown as Record<string, unknown>;
            if (first && 'pmsType' in first) {
                return (data as PmsConfigSaveData[]).flatMap((item) => buildPmsPayload(item));
            }
            return data as PmsConfigArray;
        }
        const { pmsType, formData } = data;

        switch (pmsType) {
            case 'yardi': {
                const f = formData as import('./PMSConfiguration/type').YardiFormState;
                return [
                    {
                        pms_key: 'yardi',
                        pms_config: {
                            yardiId: f.propertyId,
                            yardiUserName: f.username,
                            yardiPassword: f.password,
                            yardiServerName: f.serverName,
                            yardiTransactionSource: f.transactionSource,
                            yardiUrl: f.beansPath,
                            agentFirstName: f.agentFirstName,
                            agentLastName: f.agentLastName,
                        },
                    },
                ];
            }
            case 'entrata': {
                const f = formData as EntrataFormState;
                return [
                    {
                        pms_key: 'entrata',
                        pms_config: {
                            entrataUserName: f.username,
                            entrataPassword: f.password,
                            entrataPropertyId: f.propertyId,
                            entrataUrl: f.entrataURL,
                            entrataSubDomain: f.entrataName,
                            entrataOriginatingLeadSourceId: f.originatingSourceId,
                        },
                    },
                ];
            }
            case 'realpage': {
                const f = formData as import('./PMSConfiguration/type').RealpageFormState;
                return [
                    {
                        pms_key: 'realpage',
                        pms_config: {
                            realPagePmcID: f.pmcId,
                            realPageSiteID: f.siteId,
                            buildingId: f.buildingId,
                            realPageL2LPropertyId: f.l2lPropertyId,
                        },
                    },
                ];
            }
            case 'resman': {
                const f = formData as ResmanFormState;
                return [
                    {
                        pms_key: 'resman',
                        pms_config: {
                            resmanAccountID: f.accountId,
                            resmanPropertyID: f.propertyId,
                            resmanAgentID: f.agentId,
                            resmanTransactionSource: f.transactionSource,
                        },
                    },
                ];
            }
            case 'knock': {
                const f = formData as KnockFormState;
                return [
                    {
                        pms_key: 'knock',
                        pms_config: {
                            knockCommunityId: f.knockCommunityId || '',
                            knockAgentUserName: f.knockAgentUserName || '',
                            knockSourceTitle: f.knockSourceTitle || '',
                            knockCompanyId: f.knockCompanyId || '',
                            knockPropertyId: f.knockPropertyId || '',
                        },
                    },
                ];
            }
            case "funnel": {
                const f = formData as import('./PMSConfiguration/type').FunnelFormState;
                return [
                    {
                        pms_key: "funnel",
                        pms_config: {
                            funnelCommunityId: f.funnelCommunityId || '',
                        },
                    },
                ];
            }

            default:
                return [];
        }
    };

    const submitHandler = async (e: React.FormEvent) => {
        const leasingAgentNumberDigits = addLocationObj?.leasingAgentNumber?.toString()?.length;
        setExcelError('');
        if (!showToast) {
            e.preventDefault();
            const { ...rest } = addLocationObj;
            const restObj: Rest = rest;

            for (const prop of propertiesToDelete) {
                delete restObj[prop];
            }

            const emptyTabIndexes: number[] = [];
            const erroredFieldsObject: { [key: string]: boolean } = errorsObj;

            let toastMessage = '';

            validateTabs.forEach((tab, index) => {
                if (emptyTabIndexes.length) {
                    return;
                }
                const [tabKey] = Object.keys(tab);
                const tabKeys = tab[tabKey];

                let hasEmptyKey =
                    Array.isArray(tabKeys) &&
                    tabKeys.some((key) => {
                        if (
                            key === 'masterCode' &&
                            getLockerVersion() &&
                            typeof getLockerVersion() === 'string' &&
                            getLockerVersion().toLowerCase() === 'kiosk' &&
                            addLocationObj.lockerName &&
                            addLocationObj.lockerName.toLowerCase() !== 'bms'
                        ) {
                            if (!otpValue || otpValue.length === 0) {
                                toastMessage = 'Master Code is required for Kiosk locker.';
                                return true;
                            }
                            if (otpValue.length !== 6) {
                                toastMessage = 'Master Code must be exactly 6 digits for Kiosk locker.';
                                return true;
                            }
                            return false;
                        }
                        const isAnyEmpty =
                            (key !== 'masterCode' && restObj[key] === '') ||
                            (key === 'mastercode' && String(otpValue).split('').length === 0) ||
                            (existingImages.length === 0 && uploadFiles.length === 0);

                        if (isAnyEmpty) {
                            toastMessage = 'Please fill all the required fields';
                            return true;
                        }
                        return false; // Don't proceed with URL validation if there are empty values
                    });

                if (!hasEmptyKey) {
                    // Check for empty fields first

                    if (!isValidHttpUrl(rest.contactLink)) {
                        toastMessage = 'Contact Office Link is not a valid URL';
                        hasEmptyKey = true;
                    }

                    // if (selectedLockers?.value === 0 && (addLocationObj?.luxerBuildingId === '' || addLocationObj?.luxerBuildingId === undefined)) {
                    //     toastMessage = 'Luxer building id is required.';
                    //     hasEmptyKey = true;
                    // }

                    if (!isValidHttpUrl(rest.appLink)) {
                        toastMessage = 'Lease Application Link is not a valid URL';
                        hasEmptyKey = true;
                    }

                    if (getLockerVersion() === 'Kiosk' && String(otpValue).split('').length) {
                        if (otpValue?.length !== 6) {
                            toastMessage = 'Master Code must be equal to 6 digits';
                            hasEmptyKey = true;
                        }
                    }

                    if (tab.tabIndex === 2 && !hasEmptyKey) {
                        if (addLocationObj.resmanPropertyID?.length && addLocationObj?.resmanTransactionSource === '') {
                            toastMessage = 'Please enter Resman Transaction source';
                            hasEmptyKey = true;
                        }
                        // if (
                        //     (addLocationObj?.realPagePmcID?.length || addLocationObj?.realPageSiteID?.length) &&
                        //     addLocationObj?.realpageMarketingSourceId === ''
                        // ) {
                        //     toastMessage = 'Please enter Real page marketing source Id';
                        //     hasEmptyKey = true;
                        // }
                        if (addLocationObj?.entrataUrl?.length && !isValidHttpUrl(addLocationObj?.entrataUrl)) {
                            toastMessage = 'Entrata Url is not a valid URL';
                            hasEmptyKey = true;
                        }
                        if (addLocationObj?.entrataPropertyId?.length && addLocationObj?.entrataOriginatingLeadSourceId === '') {
                            toastMessage = 'Please enter entrata originating lead source id';
                            hasEmptyKey = true;
                        }
                        if (addLocationObj?.yardiId?.length && addLocationObj?.yardiTransactionSource === '') {
                            toastMessage = 'Please enter Yardi Transaction Source';
                            hasEmptyKey = true;
                        }
                        if (
                            addLocationObj?.yardiId?.length &&
                            addLocationObj?.agentFirstName === '' &&
                            addLocationObj?.agentLastName === ''
                        ) {
                            toastMessage = 'Please enter Agent First Name or Last Name';
                            hasEmptyKey = true;
                        }

                        if (addLocationObj?.yardiUrl?.length && !isValidHttpUrl(addLocationObj?.yardiUrl)) {
                            toastMessage = 'Yardi Url is not a valid URL';
                            hasEmptyKey = true;
                        }

                        if (
                            addLocationObj?.knockCommunityId?.length &&
                            addLocationObj?.knockSourceTitle === '' &&
                            addLocationObj?.knockCompanyId === '' &&
                            addLocationObj?.knockPropertyId === ''
                        ) {
                            toastMessage = 'Please Enter knock Source Title , company and property Id';
                            hasEmptyKey = true;
                        }
                    }

                    if (addLocationObj?.googlePlacesId && !addLocationObj?.radius) {
                        toastMessage = 'Radius is required.';
                        hasEmptyKey = true;
                    }

                    if (addLocationObj?.leasingAgentEmailId.length && !emailRegex.test(addLocationObj?.leasingAgentEmailId)) {
                        toastMessage = 'Please enter valid Leasing agent email address';
                        hasEmptyKey = true;
                    }

                    if (
                        addLocationObj?.showCardDisclaimer.toLowerCase() === 'true' &&
                        (addLocationObj?.customCardDisclaimer?.trim() === '' || addLocationObj.customCardDisclaimer === null)
                    ) {
                        toastMessage = 'Please enter credit card disclaimer';
                        hasEmptyKey = true;
                    }
                }

                if (hasEmptyKey) {
                    emptyTabIndexes.push(tab.tabIndex);
                }
                return;
            });

            for (const key in restObj) {
                if (restObj[key] === '') {
                    erroredFieldsObject[key] = true;
                } else {
                    erroredFieldsObject[key] = false;
                }
            }

            if (emptyTabIndexes?.length) {
                setShowToast(true);
                setToastMessage(toastMessage);
                setTimeout(() => setShowToast(false), 4000);
                if (otpValue?.length !== 6) {
                    setActiveTab(0);
                    return;
                }
                if (!isValidHttpUrl(rest.appLink)) {
                    setActiveTab(0);
                    return;
                }

                if (!isValidHttpUrl(rest.contactLink)) {
                    setActiveTab(0);
                    return;
                }

                if (
                    addLocationObj?.showCardDisclaimer.toLowerCase() === 'true' &&
                    (addLocationObj?.customCardDisclaimer?.trim() === '' || addLocationObj.customCardDisclaimer === null)
                ) {
                    setActiveTab(0);
                    return;
                }

                if (
                    addLocationObj?.leasingAgentEmailId.length &&
                    !addLocationObj?.leasingAgentEmailId.match(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)
                ) {
                    setActiveTab(0);
                    return;
                }

                // if (selectedLockers?.value === 0 && (addLocationObj?.luxerBuildingId === '' || addLocationObj?.luxerBuildingId === undefined)) {
                //     setActiveTab(0);
                //     return;
                // }

                if (addLocationObj?.googlePlacesId && !addLocationObj?.radius) {
                    setActiveTab(1);
                    setClicked('0');
                    return;
                }

                if (emptyTabIndexes[0] === 2) {
                    if (addLocationObj?.yardiUrl.length) {
                        if (!isValidHttpUrl(addLocationObj?.yardiUrl)) {
                            setActiveTab(2);
                            setClicked('0');
                            return;
                        }
                    }

                    if (addLocationObj?.yardiId?.length && addLocationObj?.agentFirstName === '' && addLocationObj?.agentLastName === '') {
                        setActiveTab(2);
                        setClicked('0');
                        return;
                    }

                    if (addLocationObj?.yardiId.length && addLocationObj?.agentFirstName === '' && addLocationObj?.agentLastName === '') {
                        setActiveTab(2);
                        setClicked('0');
                        return;
                    }

                    if (addLocationObj?.yardiId?.length && addLocationObj?.yardiTransactionSource === '') {
                        setActiveTab(2);
                        setClicked('0');
                        return;
                    }

                    if (addLocationObj?.entrataUrl.length) {
                        if (!isValidHttpUrl(addLocationObj?.entrataUrl)) {
                            setActiveTab(2);
                            setClicked('1');
                            return;
                        }
                    }

                    if (addLocationObj?.entrataPropertyId?.length && addLocationObj?.entrataOriginatingLeadSourceId === '') {
                        setActiveTab(2);
                        setClicked('1');
                        return;
                    }

                    // if (
                    //     (addLocationObj?.realPagePmcID?.length || addLocationObj?.realPageSiteID?.length) &&
                    //     addLocationObj?.realpageMarketingSourceId === ''
                    // ) {
                    //     setActiveTab(2);
                    //     setClicked('3');
                    //     return;
                    // }

                    if (
                        addLocationObj?.knockCommunityId?.length &&
                        addLocationObj?.knockSourceTitle === '' &&
                        addLocationObj?.knockCompanyId === '' &&
                        addLocationObj?.knockPropertyId === ''
                    ) {
                        setActiveTab(2);
                        setClicked('3');
                        return;
                    }

                    if (addLocationObj.resmanPropertyID?.length) {
                        if (addLocationObj?.resmanTransactionSource === '') {
                            setActiveTab(2);
                            setClicked('4');
                            return;
                        }
                    }
                }
                return;
            }

            // const pmsConfig = [
            //     {
            //         pms_config: {
            //             yardiId: addLocationObj?.yardiId,
            //             yardiUserName: addLocationObj?.yardiUserName,
            //             yardiPassword: addLocationObj?.yardiPassword,
            //             yardiServerName: addLocationObj?.yardiServerName,
            //             yardiTransactionSource: addLocationObj?.yardiTransactionSource,
            //             yardiUrl: addLocationObj?.yardiUrl,
            //             agentFirstName: addLocationObj?.agentFirstName,
            //             agentLastName: addLocationObj?.agentLastName,
            //         },
            //         pms_key: 'yardi',
            //     },
            //     {
            //         pms_config: {
            //             entrataUserName: addLocationObj?.entrataUserName,
            //             entrataPassword: addLocationObj?.entrataPassword,
            //             entrataPropertyId: addLocationObj?.entrataPropertyId,
            //             entrataSubDomain: addLocationObj?.entrataSubDomain,
            //             entrataUrl: addLocationObj?.entrataUrl,
            //             entrataOriginatingLeadSourceId: addLocationObj?.entrataOriginatingLeadSourceId,
            //         },
            //         pms_key: 'entrata',
            //     },
            //     {
            //         pms_config: {
            //             buildingId: addLocationObj?.buildingId,
            //             realPagePmcID: addLocationObj?.realPagePmcID,
            //             realPageSiteID: addLocationObj?.realPageSiteID,
            //             pineappleLeasingAgentID: addLocationObj?.pineappleLeasingAgentID,
            //             realPageL2LPropertyId: addLocationObj?.realPageL2LPropertyId,
            //             realPageILMPropertyId: addLocationObj?.realPageILMPropertyId,
            //             realpageMarketingSourceId: addLocationObj.realpageMarketingSourceId || '',
            //         },
            //         pms_key: 'realpage',
            //     },
            //     {
            //         pms_config: {
            //             resmanAccountID: addLocationObj.resmanAccountID,
            //             resmanPropertyID: addLocationObj.resmanPropertyID,
            //             resmanAgentID: addLocationObj.resmanAgentID,
            //             resmanTransactionSource: addLocationObj.resmanTransactionSource,
            //         },
            //         pms_key: 'resman',
            //     },
            //     {
            //         pms_config: {
            //             knockCommunityId: addLocationObj.knockCommunityId,
            //             knockAgentUserName: addLocationObj.knockAgentUserName,
            //             knockSourceTitle: addLocationObj.knockSourceTitle || '',
            //             knockCompanyId: addLocationObj.knockCompanyId || '',
            //             knockPropertyId: addLocationObj.knockPropertyId || '',
            //         },
            //         pms_key: 'knock',
            //     },
            //     {
            //         pms_config: {
            //             funnelCommunityId: addLocationObj?.funnelCommunityId,
            //         },
            //         pms_key: 'funnel',
            //     },
            // ];

            const newArray = message.map(({ id, ...rest }) => rest);

            if (addLocationObj?.confirmText.trim() === '') {
                setShowToast(true);
                setToastMessage('Please fill all the required fields');
                setTimeout(() => setShowToast(false), 4000);
                setLoading(false);
                return;
            }

            const {
                yardiId,
                yardiPassword,
                yardiServerName,
                yardiTransactionSource,
                yardiUrl,
                yardiUserName,
                agentFirstName,
                agentLastName,
                funnelCommunityId,
                entrataPassword,
                entrataPropertyId,
                entrataOriginatingLeadSourceId,
                entrataUrl,
                entrataUserName,
                entrataSubDomain,
                buildingId,
                realPagePmcID,
                realPageSiteID,
                pineappleLeasingAgentID,
                realPageL2LPropertyId,
                realPageILMPropertyId,
                resmanAccountID,
                resmanAgentID,
                resmanPropertyID,
                resmanTransactionSource,
                realpageMarketingSourceId,
                knockCommunityId,
                knockAgentUserName,
                knockSourceTitle,
                knockCompanyId,
                knockPropertyId,
                isPriceListed,
                ...restAddLocationObj
            } = addLocationObj;
            let uploadImgs: void | string[] = [];
            const isBotUpdated = locationDetail?.location?.propertyDetailsForBot !== addLocationObj?.propertyDetailsForBot;
            const isOfficeHoursChanged = oldOfficeHours !== officeHours;

            const mapFilePath = await uploadMapFile();
            if (videoFile.file) {
                setLoading(true);
                const uploadedVideoUrl = await uploadFile(videoFile.file, 'location');
                restAddLocationObj.videoUrl = typeof uploadedVideoUrl === 'string' ? uploadedVideoUrl : '';
            }
            const pmsConfig = locationID.id
                ? (() => {
                      const existing = (locationDetail?.location?.pmsConfig || []) as PmsConfigArray;
                      const newPayloads = buildPmsPayload(newlyConnectedPmsEdit);
                      const keysFromNew = new Set(newPayloads.map((x: { pms_key: string }) => x.pms_key));
                      const kept = existing.filter(
                          (x: { pms_key: string }) => !keysFromNew.has(x.pms_key) && !deletedPmsKeys.has(x.pms_key),
                      );
                      // Pass deleted PMSs with pms_config as empty keys so backend can recognize and remove them
                      const deletedPayloads = [...deletedPmsKeys].map((pms_key) => ({
                          pms_key,
                          pms_config: getEmptyPmsConfigForDelete(pms_key),
                      }));
                      return [...kept, ...newPayloads, ...deletedPayloads];
                  })()
                : (() => {
                      const payload = buildPmsPayload(pmsConfigData);
                      return payload.filter((item: { pms_config?: Record<string, unknown> }) => hasAnyFilledField(item?.pms_config));
                  })();
            if (uploadFiles.length) {
                setLoading(true);
                uploadImgs = await uploadImages(uploadFiles, 'location').then((response) => {
                    if (locationID.id && response.length > 0) {
                        locationID.id &&
                            dispatch(
                                editLocation(
                                    locationID.id,
                                    {
                                        ...restAddLocationObj,
                                        timeZone: selectedOption?.value,
                                        images: existingImages.length > 0 || response.length > 0 ? [...existingImages, ...response] : [],
                                        listOfPOI,
                                        masterCode: getLockerVersion() === 'Kiosk' ? otpValue : null,
                                        pmsConfig,
                                        lockersCount: getLockerVersion() === 'Kiosk' ? selectedLockers?.value : null,
                                        lockerName: addLocationObj?.lockerName,
                                        isOpenViaChecked,
                                        reportSendTime: selectedReportSendTime.value,
                                        propertyStatus: selectedStatus?.value,
                                        unitMapAssetId: addLocationObj.unitMapAssetId,
                                        unitMapId: addLocationObj.unitMapId,
                                        isPriceListed: addLocationObj?.isPriceListed === 'true' ? true : false,
                                        errorNotification: addLocationObj?.errorNotification,
                                        leasingAgentNumber: addLocationObj?.leasingAgentNumber
                                            ? Number(addLocationObj?.leasingAgentNumber)
                                            : null,
                                        leasingAgentEmailId: addLocationObj?.leasingAgentEmailId?.length
                                            ? addLocationObj?.leasingAgentEmailId
                                            : null,
                                        isBotUpdated: isBotUpdated,
                                        showCardDisclaimer: addLocationObj?.showCardDisclaimer.toLowerCase() === 'true' ? true : false,
                                        customCardDisclaimer: addLocationObj?.customCardDisclaimer
                                            ? addLocationObj?.customCardDisclaimer?.trim()
                                            : null,
                                        isCardRequired: addLocationObj?.isCardRequired == 'true' ? true : false,
                                        isDocumentRequired: addLocationObj?.isDocumentRequired == 'true' ? true : false,
                                        mapFilePath: mapFilePath,
                                        amazonKeyAccessId: addLocationObj?.amazonKeyAccessId?.trim() || null,
                                    },
                                    isOfficeHoursChanged ? officeHours : null,
                                    setLoading,
                                    navigate,
                                ),
                            );
                    } else if (response.length > 0 && !locationID.id) {
                        dispatch(
                            addLocation(
                                {
                                    ...restAddLocationObj,
                                    timeZone: selectedOption?.value,
                                    images: response,
                                    listOfPOI,
                                    tourExperienceMessages: newArray,
                                    pmsConfig,
                                    lockersCount: getLockerVersion() === 'Kiosk' ? selectedLockers?.value : null,
                                    lockerName: addLocationObj?.lockerName,
                                    isOpenViaChecked,
                                    isCardRequired: addLocationObj?.isCardRequired == 'true' ? true : false,
                                    isDocumentRequired: addLocationObj?.isDocumentRequired == 'true' ? true : false,
                                    propertyStatus: selectedStatus?.value,
                                    unitMapAssetId: addLocationObj.unitMapAssetId,
                                    unitMapId: addLocationObj.unitMapId,
                                    managementCompany: addLocationObj.managementCompany.trim(),
                                    isPriceListed: addLocationObj?.isPriceListed === ' true' ? true : false,
                                    errorNotification: addLocationObj?.errorNotification,
                                    leasingAgentNumber: addLocationObj?.leasingAgentNumber
                                        ? Number(addLocationObj?.leasingAgentNumber)
                                        : null,
                                    leasingAgentEmailId: addLocationObj?.leasingAgentEmailId?.length
                                        ? addLocationObj?.leasingAgentEmailId
                                        : null,
                                    propertyDetailsForBot: addLocationObj?.propertyDetailsForBot,
                                    showCardDisclaimer: addLocationObj?.showCardDisclaimer.toLowerCase() === 'true' ? true : false,
                                    customCardDisclaimer: addLocationObj?.customCardDisclaimer
                                        ? addLocationObj?.customCardDisclaimer?.trim()
                                        : null,
                                    mapFilePath: mapFilePath,
                                    amazonKeyAccessId: addLocationObj?.amazonKeyAccessId?.trim() || null,
                                    masterCode: getLockerVersion() === 'Kiosk' ? addLocationObj?.masterCode : null,
                                },
                                officeHours,
                                setLoading,
                                navigate,
                            ),
                        );
                    }
                });
            } else if (!time.length) {
                dispatch(addTime({ location: locationID.id, propertyOfficeHours: officeHours }, setLoading));
            } else if (!locationID.id) {
                // Add property with no images: call addLocation then redirect to locations
                dispatch(
                    addLocation(
                        {
                            ...restAddLocationObj,
                            timeZone: selectedOption?.value,
                            images: [],
                            listOfPOI,
                            tourExperienceMessages: newArray,
                            pmsConfig,
                            lockersCount: getLockerVersion() === 'Kiosk' ? selectedLockers?.value : null,
                            lockerName: addLocationObj?.lockerName,
                            isOpenViaChecked,
                            isCardRequired: addLocationObj?.isCardRequired == 'true' ? true : false,
                            isDocumentRequired: addLocationObj?.isDocumentRequired == 'true' ? true : false,
                            propertyStatus: selectedStatus?.value,
                            unitMapAssetId: addLocationObj.unitMapAssetId,
                            unitMapId: addLocationObj.unitMapId,
                            managementCompany: addLocationObj.managementCompany.trim(),
                            isPriceListed: addLocationObj?.isPriceListed === 'true' ? true : false,
                            errorNotification: addLocationObj?.errorNotification,
                            leasingAgentNumber: addLocationObj?.leasingAgentNumber ? Number(addLocationObj?.leasingAgentNumber) : null,
                            leasingAgentEmailId: addLocationObj?.leasingAgentEmailId?.length ? addLocationObj?.leasingAgentEmailId : null,
                            propertyDetailsForBot: addLocationObj?.propertyDetailsForBot,
                            showCardDisclaimer: addLocationObj?.showCardDisclaimer.toLowerCase() === 'true' ? true : false,
                            customCardDisclaimer: addLocationObj?.customCardDisclaimer
                                ? addLocationObj?.customCardDisclaimer?.trim()
                                : null,
                            mapFilePath: mapFilePath,
                            amazonKeyAccessId: addLocationObj?.amazonKeyAccessId?.trim() || null,
                            masterCode: getLockerVersion() === 'Kiosk' ? addLocationObj?.masterCode : null,
                        },
                        officeHours,
                        setLoading,
                        navigate,
                    ),
                );
            } else {
                locationID.id &&
                    dispatch(
                        editLocation(
                            locationID.id,
                            {
                                ...restAddLocationObj,
                                timeZone: selectedOption?.value,
                                images: existingImages.length > 0 || uploadImgs.length > 0 ? [...existingImages, ...uploadImgs] : [],
                                listOfPOI,
                                masterCode: getLockerVersion() === 'Kiosk' ? otpValue : null,
                                pmsConfig,
                                lockersCount: getLockerVersion() === 'Kiosk' ? selectedLockers?.value : null,
                                lockerName: addLocationObj?.lockerName,
                                isOpenViaChecked,
                                isCardRequired: addLocationObj?.isCardRequired == 'true' ? true : false,
                                isDocumentRequired: addLocationObj?.isDocumentRequired == 'true' ? true : false,
                                propertyStatus: selectedStatus?.value,
                                reportSendTime: selectedReportSendTime.value,
                                managementCompany: addLocationObj.managementCompany.trim(),
                                isPriceListed: addLocationObj?.isPriceListed === 'true' ? true : false,
                                errorNotification: addLocationObj?.errorNotification,
                                leasingAgentNumber: addLocationObj?.leasingAgentNumber ? Number(addLocationObj?.leasingAgentNumber) : null,
                                leasingAgentEmailId: addLocationObj?.leasingAgentEmailId?.length
                                    ? addLocationObj?.leasingAgentEmailId
                                    : null,
                                isBotUpdated: isBotUpdated,
                                showCardDisclaimer: addLocationObj?.showCardDisclaimer.toLowerCase() === 'true' ? true : false,
                                customCardDisclaimer: addLocationObj?.customCardDisclaimer
                                    ? addLocationObj?.customCardDisclaimer?.trim()
                                    : null,
                                mapFilePath: mapFilePath,
                                amazonKeyAccessId: addLocationObj?.amazonKeyAccessId?.trim() || null,
                            },
                            isOfficeHoursChanged ? officeHours : null,
                            setLoading,
                            navigate,
                        ),
                    );
            }
        }
    };

    const changeHandler = (e: React.FormEvent<HTMLInputElement> | React.FormEvent<HTMLTextAreaElement>) => {
        if ((e.target as HTMLInputElement).name === 'radius') {
            setAddLocationObj({
                ...addLocationObj,
                [(e.target as HTMLInputElement).name]: Number((e.target as HTMLInputElement).value),
            });
        }
        if ((e.target as HTMLInputElement).name === 'zip') {
            if ((e.target as HTMLInputElement).value.length > 9) {
                return;
            }
            setAddLocationObj({
                ...addLocationObj,
                [(e.target as HTMLInputElement).name]: (e.target as HTMLInputElement).value,
            });
        } else if ((e.target as HTMLInputElement).name === 'streetNumber') {
            setAddLocationObj({
                ...addLocationObj,
                [(e.target as HTMLInputElement).name]: (e.target as HTMLInputElement).value.replace(/[^0-9]/g, ''),
            });
        } else if ((e.target as HTMLInputElement).name === 'leasingAgentNumber') {
            setAddLocationObj({
                ...addLocationObj,
                [(e.target as HTMLInputElement).name]: (e.target as HTMLInputElement)?.value?.length
                    ? Number((e.target as HTMLInputElement)?.value.replace(/[^0-9]/g, '').substring(0, 10))
                    : '',
            });
        } else if ((e.target as HTMLInputElement).name === 'leasingAgentEmailId') {
            setAddLocationObj({
                ...addLocationObj,
                [(e.target as HTMLInputElement).name]: (e.target as HTMLInputElement)?.value?.length
                    ? (e.target as HTMLInputElement).value.trim()
                    : '',
            });
        } else if ((e.target as HTMLInputElement).name === 'radius') {
            const value = (e.target as HTMLInputElement).value;
            if (/^(\d+(\.\d*)?|\.\d+)$/.test(value)) {
                setAddLocationObj({
                    ...addLocationObj,
                    radius: parseFloat(value as string),
                });
            }
            if (value === '' || value === '0') {
                setAddLocationObj({
                    ...addLocationObj,
                    radius: 0,
                });
            }
        } else {
            setAddLocationObj({
                ...addLocationObj,
                [(e.target as HTMLInputElement).name]: (e.target as HTMLInputElement).value,
            });
        }
        // if ((e.target as HTMLInputElement).name === 'yardiUserName') {
        //     setAddLocationObj((prevState) => {
        //         return {
        //             ...prevState,
        //             [(e.target as HTMLInputElement).name]: (e.target as HTMLInputElement).value.replace(/[^a-zA-Z0-9\s]/g, ''),
        //         };
        //     });
        // }
    };

    const phoneNumberHandler = (value: string, country: CountryData) => {
        setPhoneNumberLength(country?.format?.length);
        setAddLocationObj((prevState) => {
            return {
                ...prevState,
                leasingAgentNumber: value,
            };
        });
    };

    const officeHoursChangeHandler = (e: Date | null, index: number, isOpen: boolean, onChangeFlag: string) => {
        const openTime = moment(e).format('HH:mm');

        switch (onChangeFlag) {
            case 'toggle':
                {
                    const newArr = [...officeHours];

                    newArr[index].isOpen = !isOpen;

                    setOfficeHours([...newArr]);
                }
                break;

            case 'openTime':
                {
                    const tempArr = [...officeHours];

                    const startTime = moment(openTime, 'HH:mm', true);

                    if (startTime.isValid()) {
                        const endTime = moment.max(startTime, moment(tempArr[index].closeTime, 'HH:mm', true));
                        tempArr[index].openTime = startTime.format('HH:mm');
                        tempArr[index].closeTime = endTime.format('HH:mm');

                        setOfficeHours([...tempArr]);
                    }
                }
                break;

            case 'closeTime':
                {
                    const tempArr = [...officeHours];
                    const endTime = moment(openTime, 'HH:mm', true);

                    if (endTime.isValid()) {
                        const openTime = moment(tempArr[index].openTime, 'HH:mm').format('HH:mm');
                        const closeTime = endTime.format('HH:mm');
                        if (openTime <= closeTime) {
                            const startTime = moment.min(endTime, moment(tempArr[index].openTime, 'HH:mm', true));
                            tempArr[index].openTime = startTime.format('HH:mm');
                            tempArr[index].closeTime = endTime.format('HH:mm');
                            setOfficeHours([...tempArr]);
                        }
                    }
                }
                break;

            default:
                return officeHours;
        }
    };

    const onChangeHandler = (index: number, isOpen: boolean) => {
        const newArr = [...officeHours];
        newArr[index].isOpen = !isOpen;
        setOfficeHours([...newArr]);
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>, fieldName: keyof addLocationObj) => {
        if (event.key === ' ' && (addLocationObj[fieldName] as string)?.length === 0) {
            event.preventDefault();
        }
    };
    const onEditorChange = (value: string | null) => {
        setAddLocationObj((addLocationObj) => {
            return {
                ...addLocationObj,
                propertyDetailsForBot: value,
            };
        });
    };

    const removeImageTags = (htmlString: string) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const images = doc.querySelectorAll('img');
        images.forEach((img) => img.remove());
        return doc.body.innerHTML;
    };

    const readFileAsDataURL = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.result) {
                    resolve(reader.result as string);
                } else {
                    reject(new Error('Failed to read file'));
                }
            };
            reader.onerror = () => {
                reject(new Error('Failed to read file'));
            };
            reader.readAsDataURL(file);
        });
    };

    const createBlobUrl = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            try {
                const blobUrl = URL.createObjectURL(file);
                resolve(blobUrl);
            } catch (error) {
                reject(error);
            }
        });
    };

    const readFile = async (file: File | null, url: string | null) => {
        const iframe = document.getElementById('file-viewer') as HTMLIFrameElement;
        if (file) {
            if (file.size > 1 * 1024 * 1024) {
                // 1 MB
                const fileUrl = await createBlobUrl(file);
                const iframe = document.getElementById('file-viewer') as HTMLIFrameElement;
                if (iframe) {
                    iframe.src = fileUrl;
                }
            } else {
                const fileUrl = await readFileAsDataURL(file);

                if (iframe) {
                    iframe.src = fileUrl;
                }
            }
        } else if (url) {
            if (iframe) {
                iframe.src = url;
            }
        }
    };

    const ViewUploadedFile = () => {
        return (
            <div className={styles.viewFileModal}>
                {existingMapFile?.name && existingMapFile.type === 'application/pdf' ? (
                    <iframe id="file-viewer" title="file-viewer" height={'100%'} width={'100%'} style={{ border: 'none' }} loading="lazy" />
                ) : mapFile.file && mapFile.file.type === 'application/pdf' ? (
                    <iframe
                        id="file-viewer"
                        title="file-viewer"
                        height={'100%'}
                        width={'100%'}
                        style={{ border: 'none' }}
                        loading="lazy"
                        src={URL.createObjectURL(mapFile.file)}
                    />
                ) : (
                    <div className={styles.imagePreviewContainer}>
                        <img
                            src={mapFile.file ? URL.createObjectURL(mapFile.file) : locationDetail.location.mapFilePath}
                            width={'100%'}
                            height={'100%'}
                        />
                    </div>
                )}
            </div>
        );
    };

    const pmsOptionsMap: Record<string, { icon: React.ReactNode; label: string }> = {
        yardi: { icon: <YardiPMSIcon />, label: 'Yardi' },
        entrata: { icon: <EntrataPMSIcon />, label: 'Entrata' },
        realpage: { icon: <RealPagePMSIcon />, label: 'RealPage OneSite' },
        resman: { icon: <ResmanPMSIcon />, label: 'ResMan' },
        knock: { icon: <KnockPMSIcon />, label: 'Knock' },
        funnel: { icon: <FunnelPMSIcon />, label: 'Funnel' },
    };
    const [openMenu, setOpenMenu] = useState<string | null>(null);

    // Show PMS in listing only when: has id AND at least one field in pms_config is filled
    // No id = never show. Empty pms_config (all "" or empty) = don't show.
    const hasAnyFilledField = (pmsConfig: Record<string, unknown> | undefined): boolean => {
        if (!pmsConfig || typeof pmsConfig !== 'object') return false;
        return Object.values(pmsConfig).some((val) => val != null && val !== '' && String(val).trim() !== '');
    };

    const connectedPmsList = useMemo(() => {
        if (!pmsConfigObject || !Array.isArray(pmsConfigObject)) return [];
        return pmsConfigObject.filter(
            (pms: { id?: string; pms_key: string; pms_config?: Record<string, unknown> }) =>
                pms?.id && hasAnyFilledField(pms?.pms_config)
        );
    }, [pmsConfigObject]);

    // Show "No PMS Connected Yet" only when there is no PMS to show (edit: from API; add: from just-connected pmsConfigData)
    const isCreateProperty = pathName.includes('add-location');

    /** In add flow, list of PMS configs connected but not saved yet (single object or array). Empty when edit or API-shape. */
    const pendingPmsList = useMemo((): PmsConfigSaveData[] => {
        if (!isCreateProperty || !pmsConfigData) return [];
        if (Array.isArray(pmsConfigData)) {
            const first = pmsConfigData[0] as unknown as Record<string, unknown> | undefined;
            if (first && 'pms_key' in first) return [];
            return pmsConfigData as unknown as PmsConfigSaveData[];
        }
        return [pmsConfigData as PmsConfigSaveData];
    }, [isCreateProperty, pmsConfigData]);

    const hasPmsConnected = connectedPmsList.length > 0 || pendingPmsList.length > 0 || newlyConnectedPmsEdit.length > 0;

    const [pmsData, setPmsData] = useState<{ key: string; icon: React.ReactNode; label: string; status: string; connectedDate: string }[]>(
        [],
    );

    useEffect(() => {
        if (connectedPmsList.length > 0 || newlyConnectedPmsEdit.length > 0) {
            const cardFromApi = (pms: { pms_key: string; updated_at?: string; created_at?: string }) => {
                const opt = pmsOptionsMap[pms.pms_key] || { icon: <RealPagePMSIcon />, label: pms.pms_key };
                const dateStr = pms.updated_at || pms.created_at;
                const connectedDate = dateStr ? moment(dateStr).format('MMM DD, YYYY') : 'Connected';

                const pmsLogs = (locationDetail as any)?.pmsLogs || [];
                const latestLog = pmsLogs
                    .filter((log: any) => log.pms_key === pms.pms_key)
                    .sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())[0];
                const hasFailure = latestLog?.status === 'failure';
                const status = hasFailure ? 'failure' : 'active';

                return { key: pms.pms_key, icon: opt.icon, label: opt.label, status, connectedDate };
            };
            const cardFromNew = (item: PmsConfigSaveData) => {
                const opt = pmsOptionsMap[item.pmsType] || { icon: <RealPagePMSIcon />, label: item.pmsType };
                return { key: item.pmsType, icon: opt.icon, label: opt.label, status: 'active', connectedDate: 'Just connected' };
            };
            const byKey: Record<string, { key: string; icon: React.ReactNode; label: string; status: string; connectedDate: string }> = {};
            connectedPmsList.forEach((pms: { pms_key: string; updated_at?: string; created_at?: string }) => {
                byKey[pms.pms_key] = cardFromApi(pms);
            });
            newlyConnectedPmsEdit.forEach((item) => {
                byKey[item.pmsType] = cardFromNew(item);
            });
            const orderKeys = [
                ...connectedPmsList.map((p: { pms_key: string }) => p.pms_key),
                ...newlyConnectedPmsEdit
                    .map((p) => p.pmsType)
                    .filter((k) => !(connectedPmsList as { pms_key: string }[]).some((p) => p.pms_key === k)),
            ];
            setPmsData(orderKeys.map((k) => byKey[k]).filter(Boolean));
        } else if (pendingPmsList.length > 0) {
            setPmsData(
                pendingPmsList.map((item) => {
                    const opt = pmsOptionsMap[item.pmsType] || { icon: <RealPagePMSIcon />, label: item.pmsType };
                    return {
                        key: item.pmsType,
                        icon: opt.icon,
                        label: opt.label,
                        status: 'active',
                        connectedDate: 'Just connected',
                    };
                }),
            );
        } else {
            setPmsData([]);
        }
    }, [connectedPmsList, pendingPmsList, newlyConnectedPmsEdit, locationDetail]);

    const wrapperRef = useRef<HTMLDivElement | null>(null);

    /**
     * Maps backend pms_config (or local pmsConfigData in add flow) to the PMS form state for edit mode.
     * Returns form data for the given pms_key, or null if not found.
     */
    const getEditFormData = useMemo(() => {
        if (!editingPmsKey) return null;
        // Add flow or edit (newly connected): use pending / newlyConnected list so Edit opens modal with form pre-filled
        const pending =
            pendingPmsList.find((c) => c.pmsType === editingPmsKey) ?? newlyConnectedPmsEdit.find((c) => c.pmsType === editingPmsKey);
        if (pending) {
            return { [pending.pmsType]: pending.formData } as unknown as Record<string, Record<string, string>>;
        }
        if (!pmsConfigObject || !Array.isArray(pmsConfigObject)) return null;
        const pmsItem = pmsConfigObject.find((p: { pms_key: string; pms_config?: Record<string, unknown> }) => p.pms_key === editingPmsKey);
        if (!pmsItem?.pms_config) return null;
        const c = pmsItem.pms_config as Record<string, string | undefined>;

        if (editingPmsKey === 'yardi') {
            return {
                yardi: {
                    propertyId: c.yardiId ?? '',
                    username: c.yardiUserName ?? '',
                    password: c.yardiPassword ?? '',
                    serverName: c.yardiServerName ?? '',
                    beansPath: c.yardiUrl ?? '',
                    transactionSource: c.yardiTransactionSource ?? '',
                    agentFirstName: c.agentFirstName ?? '',
                    agentLastName: c.agentLastName ?? '',
                },
            };
        }
        if (editingPmsKey === 'entrata') {
            return {
                entrata: {
                    entrataURL: c.entrataUrl ?? '',
                    username: c.entrataUserName ?? '',
                    password: c.entrataPassword ?? '',
                    propertyId: c.entrataPropertyId ?? '',
                    originatingSourceId: c.entrataOriginatingLeadSourceId ?? '',
                    entrataName: c.entrataSubDomain ?? '',
                },
            };
        }
        if (editingPmsKey === 'realpage') {
            return {
                realpage: {
                    leasingAgentId: c.pineappleLeasingAgentID ?? '',
                    pmcId: c.realPagePmcID ?? '',
                    siteId: c.realPageSiteID ?? '',
                    buildingId: c.buildingId ?? '',
                    l2lPropertyId: c.realPageL2LPropertyId ?? '',
                    ilmPropertyId: c.realPageILMPropertyId ?? '',
                    marketingSourceId: c.realpageMarketingSourceId ?? '',
                    knockCommunityId: c.knockCommunityId ?? '',
                    knockSourceTitle: c.knockSourceTitle ?? '',
                    knockAgentUsername: c.knockAgentUserName ?? '',
                    knockAgentPassword: '',
                    knockCompanyId: c.knockCompanyId ?? '',
                    knockPropertyId: c.knockPropertyId ?? '',
                },
            };
        }
        if (editingPmsKey === 'resman') {
            return {
                resman: {
                    accountId: c.resmanAccountID ?? '',
                    propertyId: c.resmanPropertyID ?? '',
                    agentId: c.resmanAgentID ?? '',
                    transactionSource: c.resmanTransactionSource ?? '',
                },
            };
        }
        if (editingPmsKey === 'knock') {
            return {
                knock: {
                    knockCommunityId: c.knockCommunityId ?? '',
                    knockAgentUserName: c.knockAgentUserName ?? '',
                    knockSourceTitle: c.knockSourceTitle ?? '',
                    knockCompanyId: c.knockCompanyId ?? '',
                    knockPropertyId: c.knockPropertyId ?? '',
                },
            };
        }
        if (editingPmsKey === 'funnel') {
            return {
                funnel: {
                    funnelCommunityId: c.funnelCommunityId ?? '',
                },
            };
        }
        return null;
    }, [pmsConfigObject, editingPmsKey, pendingPmsList, newlyConnectedPmsEdit]);

    const handleOpenPmsModal = (forEditKey?: string) => {
        setEditingPmsKey(forEditKey ?? null);
        setOpenModal(true);
    };

    /** Clears addLocationObj fields for a deleted PMS so validation does not run on them on save */
    const clearAddLocationObjPmsFields = (pmsKey: string): Partial<addLocationObj> => {
        const empty = (keys: string[]) => keys.reduce((acc, k) => ({ ...acc, [k]: '' }), {} as Record<string, string>);
        switch (pmsKey) {
            case 'yardi':
                return empty([
                    'yardiId',
                    'yardiUserName',
                    'yardiPassword',
                    'yardiServerName',
                    'yardiTransactionSource',
                    'yardiUrl',
                    'agentFirstName',
                    'agentLastName',
                ]);
            case 'entrata':
                return empty([
                    'entrataUserName',
                    'entrataPassword',
                    'entrataPropertyId',
                    'entrataSubDomain',
                    'entrataUrl',
                    'entrataOriginatingLeadSourceId',
                ]);
            case 'realpage':
                return empty([
                    'buildingId',
                    'realPagePmcID',
                    'realPageSiteID',
                    'pineappleLeasingAgentID',
                    'realPageL2LPropertyId',
                    'realPageILMPropertyId',
                    'realpageMarketingSourceId',
                ]);
            case 'resman':
                return empty(['resmanAccountID', 'resmanPropertyID', 'resmanAgentID', 'resmanTransactionSource']);
            case 'knock':
                return empty(['knockCommunityId', 'knockAgentUserName', 'knockSourceTitle', 'knockCompanyId', 'knockPropertyId']);
            case 'funnel':
                return empty(['funnelCommunityId']);
            default:
                return {};
        }
    };

    /**
     * Removes a PMS from the list and ensures add/edit location will not include it (edit: excluded from pmsConfig on save).
     */
    const handleDeletePms = (key: string) => {
        setOpenMenu(null);
        const isCreate = pathName.includes('add-location');
        if (isCreate) {
            setPmsConfigData((prev) => {
                if (!prev) return null;
                const list = Array.isArray(prev) ? (prev as PmsConfigSaveData[]) : [prev as PmsConfigSaveData];
                const next = list.filter((c) => c.pmsType !== key);
                if (next.length === 0) return null;
                return next.length === 1 ? next[0] : next;
            });
            return;
        }
        const inNewlyConnected = newlyConnectedPmsEdit.some((c) => c.pmsType === key);
        if (inNewlyConnected) {
            setNewlyConnectedPmsEdit((prev) => prev.filter((c) => c.pmsType !== key));
        } else {
            setDeletedPmsKeys((prev) => new Set([...prev, key]));
            setPmsConfigObject((prev: PmsConfigArray | null) =>
                Array.isArray(prev) ? prev.filter((p: { pms_key: string }) => p.pms_key !== key) : prev,
            );
        }
        // Clear this PMS's fields from addLocationObj so save validation does not run on them (e.g. "Entrata Url is not a valid URL")
        setAddLocationObj((prev) => ({ ...prev, ...clearAddLocationObjPmsFields(key) }));
    };

    useEffect(() => {
        if (!openModal) setEditingPmsKey(null);
    }, [openModal]);

    const toggleStatus = (key: string) => {
        setPmsData((prev) =>
            prev.map((item) =>
                item.key === key
                    ? {
                          ...item,
                          status: item.status === 'active' ? 'paused' : 'active',
                      }
                    : item,
            ),
        );
    };
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
                setOpenMenu(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (!openMenu) wrapperRef.current = null;
    }, [openMenu]);

    const onConfirmDeletePMS = () => {
        if (pmsKeyToDelete) {
            handleDeletePms(pmsKeyToDelete);
            setToastMessage('Associated units will not be deleted automatically and must be removed manually.');
            setShowToast(true);
            setTimeout(() => setShowToast(false), 4000);
        }
        setShowConfirmModal(false);
        setShowActionBox(null);
        setOpenMenu(null);
        setPmsKeyToDelete(null);
    };

    const onCancelDeletePMS = () => {
        setShowConfirmModal(false);
        setPmsKeyToDelete(null);
    };

    const ActionModalBody = () => {
        return (
            <div className={styles.PMSDeleteActionModal}>
                <h2 className={styles.PMSDeleteTitle}>Are you sure you want to delete this PMS/CRM?</h2>
                <h2 className={styles.PMSDeleteDescription}>
                    {' '}
                    <b>
                        Note<span style={{ color: '#f5004a' }}>*</span>
                    </b>{' '}
                    : Associated units will not be deleted automatically and must be removed manually.
                </h2>
                <div className={styles.PMSDeleteActions}>
                    <button className={styles.PMSDeleteCancelButton} onClick={onCancelDeletePMS}>
                        Cancel
                    </button>
                    <button className={styles.PMSDeleteConfirmButton} onClick={onConfirmDeletePMS}>
                        Confirm
                    </button>
                </div>
            </div>
        );
    };

    return (
        <>
            {loading || locationDetailLoading ? (
                <Loader />
            ) : (
                <div className={`${styles.addPropertyWrapper} outletConainer`}>
                    {showToast && <Toast type="delete" message={toastMessage} />}
                    <div className={styles.propertyHeader}>
                        <div className={styles.propertyBack}>
                            <span className={styles.backImage} onClick={closeModal}>
                                <img src={backArrow} alt="" />
                            </span>
                            <span className={styles.propertyTitle}>{locationID?.id ? 'Edit' : 'Add'} Property</span>
                        </div>

                        {canReadLogs &&
                            locationID?.id &&
                            activeTab === 0 &&
                            !officeHoursLoading &&
                            officeHourData &&
                            officeHourData?.auditLogs &&
                            !!officeHourData?.auditLogs?.length && (
                                <button className={styles.viewBtn} onClick={() => setShowPropertyInformationLogs(true)}>
                                    <HistoryIcon fill="#51ab86" />
                                    <span>View Property Information History</span>
                                </button>
                            )}
                        {canReadLogs &&
                            locationID?.id &&
                            activeTab === 3 &&
                            !officeHoursLoading &&
                            officeHourData &&
                            officeHourData?.auditLogs &&
                            !!officeHourData?.auditLogs?.length && (
                                <button className={styles.viewBtn} onClick={() => setShowLogsModal(true)}>
                                    <HistoryIcon fill="#51ab86" />
                                    <span>View Office Hours History</span>
                                </button>
                            )}
                    </div>
                    <div className={`${styles.tabWrapper} tabWrapper`}>
                        <Tabs selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}>
                            <TabList>
                                <Tab>Property information</Tab>
                                <Tab>Location information</Tab>
                                <Tab>PMS / CRM Configuration</Tab>
                                <Tab>Office Hours</Tab>
                                <Tab>Message Template</Tab>
                                <Tab>Chatbot Insights</Tab>
                            </TabList>

                            {/* Property information */}
                            <TabPanel>
                                <div className={styles.formWrapper}>
                                    <form onSubmit={submitHandler} id={styles.addLocationForm}>
                                        <div className={`${styles.fieldWrapper} ${styles.full}  `}>
                                            <label>
                                                Description<sup className={styles.required}>*</sup>
                                            </label>
                                            <textarea
                                                name="description"
                                                value={addLocationObj.description}
                                                placeholder="Add Description here"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'description')}
                                            />
                                        </div>
                                        <div className={styles.fieldWrapper}>
                                            <label>
                                                Name<sup className={styles.required}>*</sup>
                                            </label>
                                            <input
                                                type="text"
                                                value={addLocationObj.name}
                                                name="name"
                                                placeholder="Enter Location Name"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'name')}
                                            />
                                        </div>
                                        <div className={styles.fieldWrapper}>
                                            <label>
                                                Street Number<sup className={styles.required}>*</sup>
                                            </label>
                                            <input
                                                type="text"
                                                value={addLocationObj.streetNumber}
                                                name="streetNumber"
                                                placeholder="Enter Street Number"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'streetNumber')}
                                            />
                                        </div>
                                        <div className={styles.fieldWrapper}>
                                            <label>
                                                Street Name<sup className={styles.required}>*</sup>
                                            </label>
                                            <input
                                                type="text"
                                                value={addLocationObj.street1}
                                                name="street1"
                                                placeholder="Enter Street Name"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'street1')}
                                            />
                                        </div>

                                        <div className={`${styles.fieldWrapper} ${styles.reactSelect}`}>
                                            <label>
                                                State<sup className={styles.required}>*</sup>
                                            </label>
                                            <Select
                                                defaultValue={selectedStates}
                                                onChange={(event: any) => {
                                                    setSelectedStates({ value: event.value, label: event.value });
                                                    setAddLocationObj((prevState: addLocationObj) => {
                                                        return {
                                                            ...prevState,
                                                            state: event.value,
                                                        };
                                                    });
                                                }}
                                                options={selecteStates}
                                                styles={colourStyles}
                                                value={selectedStates}
                                            />
                                        </div>
                                        <div className={styles.fieldWrapper}>
                                            <label>
                                                City<sup className={styles.required}>*</sup>
                                            </label>
                                            <input
                                                type="text"
                                                value={addLocationObj.city}
                                                name="city"
                                                placeholder="Enter City"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'city')}
                                            />
                                        </div>
                                        <div className={styles.fieldWrapper}>
                                            <label>
                                                Zip Code<sup className={styles.required}>*</sup>
                                            </label>
                                            <input
                                                type="number"
                                                value={addLocationObj.zip}
                                                name="zip"
                                                placeholder="Enter Zipcode"
                                                onChange={changeHandler}
                                                onKeyDown={(e: React.KeyboardEvent<HTMLElement>) => {
                                                    if (exceptThisSymbols.includes(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className={`${styles.fieldWrapper} ${styles.reactSelect}`}>
                                            <label>
                                                Timezone<sup className={styles.required}>*</sup>
                                            </label>
                                            <Select
                                                defaultValue={selectedOption}
                                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setSelectedOption(event)}
                                                options={TimeZones}
                                                styles={colourStyles}
                                                value={selectedOption}
                                            />
                                        </div>

                                        <div className={`${styles.fieldWrapper}`}>
                                            <label>
                                                Lease Application Link<sup className={styles.required}>*</sup>
                                            </label>
                                            <input
                                                type="text"
                                                value={addLocationObj.appLink}
                                                name="appLink"
                                                placeholder="Enter Lease Application Link"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'appLink')}
                                            />
                                        </div>
                                        <div className={`${styles.fieldWrapper} `}>
                                            <label>
                                                Contact Office Link <sup className={styles.required}>*</sup>
                                            </label>
                                            <input
                                                type="text"
                                                value={addLocationObj.contactLink}
                                                name="contactLink"
                                                placeholder="Enter Contact Office Link"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'contactLink')}
                                            />
                                        </div>
                                        {/* <div className={`${styles.fieldWrapper} `}>
                                                <label className={`${styles.beanPathWrapper} `}>Beans Path (Provided by Pineapple)</label>
                                                <input
                                                    type="text"
                                                    value={addLocationObj.mapUrl}
                                                    name="mapUrl"
                                                    placeholder="Enter Beans Path"
                                                    onChange={changeHandler}
                                                    onKeyPress={(e) => handleKeyPress(e, 'mapUrl')}
                                                />
                                            </div> */}

                                        {/* <div className={`${styles.fieldWrapper} `}>
                                            <label>Luxer Building ID</label>
                                            <input
                                                type="text"
                                                value={addLocationObj.luxerBuildingId}
                                                name="luxerBuildingId"
                                                placeholder="000"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'luxerBuildingId')}
                                            />
                                        </div> */}

                                        <div className={`${styles.fieldWrapper} ${styles.reactSelect}`}>
                                            <label>
                                                Locker Version<sup className={styles.required}>*</sup>
                                            </label>
                                            <Select
                                                defaultValue={
                                                    addLocationObj?.lockerName
                                                        ? LockersVersion.filter(
                                                              (option: { value: string; label: string }) =>
                                                                  option.value === addLocationObj?.lockerName,
                                                          )
                                                        : null
                                                }
                                                onChange={(selected: any) => {
                                                    setAddLocationObj({
                                                        ...addLocationObj,
                                                        lockerName: selected?.value,
                                                    });
                                                    if (selectedLockers?.value === null && selected?.label?.toLowerCase() === 'kiosk') {
                                                        setSelectedLockers({ value: 10, label: 10 });
                                                    }
                                                }}
                                                options={LockersVersion}
                                                styles={colourStyles}
                                                value={
                                                    addLocationObj?.lockerName
                                                        ? LockersVersion.filter(
                                                              (option: { value: string; label: string }) =>
                                                                  option.value === addLocationObj?.lockerName,
                                                          )
                                                        : null
                                                }
                                            />
                                        </div>

                                        {getLockerVersion() === 'Kiosk' && (
                                            <>
                                                <div className={`${styles.fieldWrapper} ${styles.reactSelect}`}>
                                                    <label>
                                                        Lockers<sup className={styles.required}>*</sup>
                                                    </label>
                                                    <Select
                                                        defaultValue={selectedLockers}
                                                        onChange={(event: any) => setSelectedLockers(event)}
                                                        options={SelectedLockers}
                                                        styles={colourStyles}
                                                        value={selectedLockers}
                                                        classNamePrefix={'react-select-locker'}
                                                    />
                                                </div>

                                                <div className={styles.masterCodeContainer}>
                                                    <label>
                                                        Master Code (for internal use only)<sup className={styles.required}>*</sup>
                                                    </label>
                                                    <div className={styles.masterCode}>
                                                        <OTPInput
                                                            istouched={isTouched}
                                                            isNumberInput
                                                            length={6}
                                                            value={otpValue}
                                                            inputClassName={styles.code}
                                                            onChangeOTP={(otp) => {
                                                                setIstouched(true);
                                                                setOtpValue(otp);
                                                                setAddLocationObj((addLocationObj) => {
                                                                    return {
                                                                        ...addLocationObj,
                                                                        masterCode: otp,
                                                                    };
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        <div className={`${styles.fieldWrapper} `}>
                                            <label>Management Company</label>
                                            <input
                                                type="text"
                                                value={addLocationObj.managementCompany}
                                                name="managementCompany"
                                                placeholder="Enter Management Company"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'managementCompany')}
                                            />
                                        </div>

                                        {/* <div className={`${styles.fieldWrapper} ${styles.poiWrapper}`}>
                                                <label>List Of POI/Amenities</label>
                                                <input
                                                    type="text"
                                                    name="poi"
                                                    value={listOfPOI}
                                                    placeholder="Enter List Of POI/Amenities"
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                        setListOfPOI(e.target.value.split(/[ ,]+/).join(',').toUpperCase());
                                                    }}
                                                />
                                            </div> */}

                                        <div className={`${styles.fieldWrapper} ${styles.reactSelect}`}>
                                            <label>Status</label>
                                            <Select
                                                defaultValue={selectedStatus}
                                                onChange={(event: any) => setSelectedStatus(event)}
                                                options={statusEnum}
                                                styles={colourStyles}
                                                value={selectedStatus}
                                                classNamePrefix={'react-select-locker'}
                                            />
                                        </div>

                                        {/* <div className={`${styles.fieldWrapper} `}>
                                                <label>Unit Asset Id</label>
                                                <input
                                                    type="text"
                                                    name="unitMapAssetId"
                                                    value={addLocationObj.unitMapAssetId}
                                                    placeholder="Enter Unit Asset Id"
                                                    onChange={changeHandler}
                                                    onKeyPress={(e) => handleKeyPress(e, 'unitMapAssetId')}
                                                />
                                            </div> */}

                                        {/* <div className={`${styles.fieldWrapper} `}>
                                            <label>Unit Map Id</label>
                                            <input
                                                type="text"
                                                name="unitMapId"
                                                value={addLocationObj.unitMapId}
                                                placeholder="Enter Unit Map Id"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'unitMapId')}
                                            />
                                        </div> */}

                                        {/* <div className={`${styles.fieldWrapper} `}>
                                            <label>Chatbot Id</label>
                                            <input
                                                type="text"
                                                name="openViaChatBotPropertyId"
                                                value={addLocationObj.openViaChatBotPropertyId || ''}
                                                placeholder="Enter Chatbot Id"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'openViaChatBotPropertyId')}
                                            />
                                        </div> */}

                                        <div className={`${styles.fieldWrapper}`}>
                                            <label>Mapped In Id / Pynwheel Connect</label>
                                            <input
                                                type="text"
                                                name="mappedInId"
                                                value={addLocationObj.mappedInId || ''}
                                                placeholder="Enter Mapped Id"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'mappedInId')}
                                            />
                                        </div>

                                        <div className={`${styles.fieldWrapper} `}>
                                            <label>Mapped In Floor Id</label>
                                            <input
                                                type="text"
                                                name="mappedInFloorId"
                                                value={addLocationObj.mappedInFloorId || ''}
                                                placeholder="Enter MappedIn Floor Id"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'mappedInFloorId')}
                                            />
                                        </div>

                                        {/* <div className={`${styles.fieldWrapper} `}>
                                            <label>Google Location</label>

                                            <GoogleAutocompleteInput
                                                onPlaceChange={(lat: number | null, long: number | null, googlePlacesId: string | null) => {
                                                    setAddLocationObj({
                                                        ...addLocationObj,
                                                        latitude: lat,
                                                        longitude: long,
                                                        googlePlacesId: googlePlacesId,
                                                    });
                                                }}
                                                googlePlacesId={addLocationObj?.googlePlacesId}
                                            />
                                        </div> */}

                                        <div className={`${styles.fieldWrapper} ${styles.reactSelect}`}>
                                            <label>Report Send Time</label>
                                            <Select
                                                defaultValue={selectedReportSendTime}
                                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                    setSelectedReportSendTime(event);
                                                }}
                                                options={ReportSendTimes}
                                                styles={colourStyles}
                                                value={selectedReportSendTime}
                                            />
                                        </div>

                                        <div className={`${styles.fieldWrapper} custom-react-tel`}>
                                            <label>Leasing Agent Number</label>
                                            <PhoneInput
                                                country={'us'}
                                                value={String(`+${addLocationObj?.leasingAgentNumber || ''}`)}
                                                onChange={phoneNumberHandler}
                                                inputStyle={{
                                                    marginLeft: '30px',
                                                }}
                                                inputProps={{ maxLength: phoneNumberLength, autoFocus: true }}
                                                countryCodeEditable={false}
                                                enableLongNumbers={true}
                                                enableSearch
                                            />
                                        </div>

                                        <div className={`${styles.fieldWrapper} `}>
                                            <label>Leasing Agent Email Id</label>
                                            <input
                                                type="text"
                                                name="leasingAgentEmailId"
                                                value={addLocationObj.leasingAgentEmailId}
                                                placeholder="Enter leasing agent email id"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => handleKeyPress(e, 'leasingAgentEmailId')}
                                            />
                                        </div>

                                        <div className={`${styles.fieldWrapper} `}>
                                            <label>Amazon Door Access Point Id</label>
                                            <input
                                                type="text"
                                                name="amazonKeyAccessId"
                                                value={addLocationObj.amazonKeyAccessId || ''}
                                                placeholder="Enter Amazon Door Access Point Id"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => {
                                                    handleKeyPress(e, 'amazonKeyAccessId');
                                                }}
                                            />
                                        </div>

                                        <div className={`${styles.fieldWrapper} `}>
                                            <label>Special Notes</label>
                                            <textarea
                                                className={styles.resizable}
                                                name="email_caption"
                                                value={addLocationObj.email_caption || ''}
                                                placeholder="Enter special notes"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => {
                                                    handleKeyPress(e, 'email_caption');
                                                }}
                                            />
                                        </div>

                                        {/* <div className={`${styles.fieldWrapper} ${styles.full}`}>
                                            <label>Kiosk API Key</label>
                                            <input
                                                type="text"
                                                name="kioskAPIkey"
                                                value={addLocationObj.kioskAPIkey || ''}
                                                placeholder="Enter Kiosk API Key"
                                                onChange={changeHandler}
                                                onKeyPress={(e) => {
                                                    handleKeyPress(e, 'kioskAPIkey')
                                                }}
                                            />
                                        </div> */}

                                        <div className={`${styles.fieldWrapper} ${styles.full}`}>
                                            <div className={styles.checkboxContainer}>
                                                <label className={styles.checkbox}>
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                            setShowMapFile(e.target.checked);
                                                            if (!e.target.checked) {
                                                                setMapFile({ file: null });
                                                                setExistingMapFile({ name: '', type: '', size: 0 });
                                                            }
                                                        }}
                                                        checked={showMapFile}
                                                    />
                                                    <div className={styles.checkboxCheckmark}></div>
                                                    <div
                                                        className={
                                                            styles.checkboxLabel
                                                        }>{`Don't have MappedIn? Upload Map PDF or Image`}</div>
                                                </label>
                                            </div>

                                            {showMapFile && !mapFile.file && !existingMapFile?.name && (
                                                <div className={styles.fileUploadContainer}>
                                                    <input
                                                        disabled={false}
                                                        id="mapFileInput"
                                                        name="mapFileInput"
                                                        className={styles.mapFileInput}
                                                        type="file"
                                                        accept="image/jpeg, image/jpg, image/png,  image/webp, application/pdf"
                                                        onChange={handleMapFileUpload}
                                                    />
                                                    {/* <img src={cloudUploadIcon} alt='cloud-upload-img' width={34} height={34} /> */}
                                                    <MapIconv2 color="#51ab86" height={64} width={64} />
                                                    <p className={styles.primaryText}>
                                                        Drag and Drop file or{' '}
                                                        <span>
                                                            <u>Click to Upload</u>
                                                        </span>
                                                    </p>
                                                    <p className={styles.primaryText}>Max size: 5 MB | image or PDF formats allowed</p>
                                                </div>
                                            )}

                                            {mapFile?.file && !existingMapFile?.name && (
                                                <div className={styles.fileContainer}>
                                                    <div className={styles.iconContainer}>
                                                        {mapFile.file.type === 'application/pdf' ? (
                                                            <PDFIcon width={37.08} height={37.08} fillColor="#51ab86" />
                                                        ) : (
                                                            <ImageIcon width={37.08} height={37.08} fill="#51ab86" />
                                                        )}
                                                        {/* <FileIcon width={'37.08'} height={'37.08'} fill='#51ab86' /> */}
                                                    </div>
                                                    <div className={`${styles.fileDetailContainer} ${styles.viewFileDetailContainer}`}>
                                                        <p className={styles.primaryText}>{mapFile?.file?.name}</p>
                                                        <p className={styles.secondaryText}>
                                                            {mapFile?.file ? bytesToMB(mapFile.file.size).toFixed(3) + ' MB' : null}
                                                        </p>

                                                        {
                                                            <div className={`${styles.close}`}>
                                                                <img
                                                                    src={iconClose}
                                                                    width={15}
                                                                    height={15}
                                                                    onClick={() => {
                                                                        setMapFile({ file: null });
                                                                    }}
                                                                    alt="Close"
                                                                />
                                                            </div>
                                                        }

                                                        {
                                                            <div
                                                                className={`${styles.view}`}
                                                                onClick={async () => {
                                                                    await setShowModal(true);
                                                                    if (mapFile.file) {
                                                                        readFile(mapFile.file, null);
                                                                    }
                                                                }}>
                                                                <EyeIcon strokeColor="#d1d2d3" height={24} width={24} strokeWidth={2} />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            )}

                                            {existingMapFile?.name && showMapFile && (
                                                <div className={styles.fileContainer}>
                                                    <div className={styles.iconContainer}>
                                                        {existingMapFile.type === 'application/pdf' ? (
                                                            <PDFIcon width={37.08} height={37.08} fillColor="#51ab86" />
                                                        ) : (
                                                            <ImageIcon width={37.08} height={37.08} fill="#51ab86" />
                                                        )}
                                                    </div>
                                                    <div className={`${styles.fileDetailContainer} ${styles.viewFileDetailContainer}`}>
                                                        <p className={styles.primaryText}>{existingMapFile.name}</p>
                                                        <p className={styles.secondaryText}>
                                                            {existingMapFile.size
                                                                ? bytesToMB(existingMapFile.size).toFixed(3) + ' MB'
                                                                : null}
                                                        </p>
                                                        {
                                                            <div
                                                                className={`${styles.view}`}
                                                                onClick={async () => {
                                                                    await setShowModal(true);
                                                                    if (mapFile.file && !existingMapFile.name) {
                                                                        readFile(mapFile.file, null);
                                                                    } else if (
                                                                        existingMapFile.name &&
                                                                        locationDetail &&
                                                                        locationDetail.location?.mapFilePath
                                                                    ) {
                                                                        readFile(null, locationDetail.location.mapFilePath);
                                                                    }
                                                                }}>
                                                                <EyeIcon strokeColor="#d1d2d3" height={24} width={24} strokeWidth={2} />
                                                            </div>
                                                        }

                                                        {
                                                            <div className={`${styles.close}`}>
                                                                <img
                                                                    src={iconClose}
                                                                    width={15}
                                                                    height={15}
                                                                    onClick={() => {
                                                                        setMapFile({ file: null });
                                                                        setExistingMapFile({ name: '', type: '', size: 0 });
                                                                    }}
                                                                    alt="Close"
                                                                />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div className={styles.unitUploadContainer}>
                                            <label>
                                                Images<sup className={styles.required}>*</sup>
                                            </label>
                                            <div className={styles.uploadWrapper}>
                                                <input
                                                    type="file"
                                                    accept="image/jpeg, image/jpg, image/png,  image/webp"
                                                    onChange={(e: AnyIfEmpty<object>) => {
                                                        if (
                                                            Array.from(e.target.files).length +
                                                                existingImages?.length +
                                                                uploadFiles?.length >
                                                                5 ||
                                                            Array.from(e.target.files).length > 5
                                                        ) {
                                                            e.preventDefault();
                                                            setShowToast(true);
                                                            setToastMessage("Can't upload more than 5 files!");
                                                            setTimeout(() => setShowToast(false), 4000);
                                                            return;
                                                        }
                                                        setLocationFiles(e.target.files);
                                                    }}
                                                    onClick={(event: AnyIfEmpty<object>) => {
                                                        event.target.value = null;
                                                    }}
                                                    multiple></input>
                                                <div className={styles.iconUnitUpload}>
                                                    <img src={iconUpload} alt="Icon Upload" />
                                                </div>

                                                {!uploadFiles.length && !existingImages.length && <p>Upload image from here</p>}
                                                {existingImages.length > 0 && (
                                                    <div className={styles.previewImgContainer}>
                                                        {existingImages.length > 0 &&
                                                            existingImages.map((image: string, index: number) => {
                                                                return (
                                                                    <div className={styles.imgWrapper} key={index}>
                                                                        <img
                                                                            className={styles.previewImg}
                                                                            src={image}
                                                                            alt="Preview Image"
                                                                        />
                                                                        <img
                                                                            className={styles.previewClose}
                                                                            onClick={() => handleDeleteExistingImage(index)}
                                                                            src={iconClosePreview}
                                                                            alt="Close Icon"
                                                                        />
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                )}

                                                {uploadFiles.length > 0 && (
                                                    <div className={styles.previewImgContainer}>
                                                        {uploadFiles.map((file: File, index: number) => {
                                                            return (
                                                                <div className={styles.imgWrapper} key={index}>
                                                                    <img
                                                                        className={styles.previewImg}
                                                                        src={URL.createObjectURL(file)}
                                                                        alt="Preview Image"
                                                                    />
                                                                    <img
                                                                        className={styles.previewClose}
                                                                        onClick={() => handleRemovePreview(index)}
                                                                        src={iconClosePreview}
                                                                        alt="Close Icon"
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className={styles.unitUploadContainer}>
                                            <label>Video</label>
                                            <div className={styles.uploadWrapper}>
                                                <input
                                                    type="file"
                                                    accept="video/mp4, video/webm, video/quicktime"
                                                    onChange={handleVideoFileUpload}
                                                    onClick={(event: AnyIfEmpty<object>) => {
                                                        event.target.value = null;
                                                    }}
                                                />
                                                <div className={styles.iconUnitUpload}>
                                                    <img src={iconUpload} alt="Icon Upload" />
                                                </div>

                                                {!videoFile.file && !addLocationObj.videoUrl && <p>Upload video from here</p>}
                                                {(videoFile.file || addLocationObj.videoUrl) && (
                                                    <div className={styles.previewImgContainer}>
                                                        <div className={styles.imgWrapper}>
                                                            <video
                                                                className={styles.previewVideo}
                                                                src={
                                                                    videoFile.file
                                                                        ? URL.createObjectURL(videoFile.file)
                                                                        : addLocationObj.videoUrl
                                                                }
                                                                controls
                                                            />
                                                            <img
                                                                className={styles.previewClose}
                                                                onClick={() => {
                                                                    setVideoFile({ file: null });
                                                                    setAddLocationObj((prevState) => ({
                                                                        ...prevState,
                                                                        videoUrl: '',
                                                                    }));
                                                                }}
                                                                src={iconClosePreview}
                                                                alt="Close Icon"
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className={styles.inlineItems}>
                                            <div className={styles.checkboxContainer}>
                                                <label className={styles.checkbox}>
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                            setIsOpenViaChecked(e.target.checked)
                                                        }
                                                        checked={isOpenViaChecked}
                                                    />
                                                    <div className={styles.checkboxCheckmark}></div>
                                                    <div className={styles.checkboxLabel}>Open Via</div>
                                                </label>
                                            </div>

                                            {/* Is Card Required Toggle */}
                                            <div className={styles.openCloseCheckbox}>
                                                <label className={styles.switch}>
                                                    <input
                                                        name="isOpen"
                                                        onChange={(e) => {
                                                            setAddLocationObj({
                                                                ...addLocationObj,
                                                                isCardRequired: e.target.checked.toString(),
                                                            });
                                                        }}
                                                        checked={addLocationObj?.isCardRequired == 'true' ? true : false}
                                                        type="checkbox"
                                                    />
                                                    <span className={`${styles.slider} ${styles.round}`}></span>
                                                </label>
                                                <span className={styles.OpenCloseText}>Credit card required for visitors</span>
                                            </div>

                                            {/* Is Document verification Required Toggle */}
                                            <div className={styles.openCloseCheckbox}>
                                                <label className={styles.switch}>
                                                    <input
                                                        name="isOpen"
                                                        onChange={(e) => {
                                                            setAddLocationObj({
                                                                ...addLocationObj,
                                                                isDocumentRequired: e.target.checked.toString(),
                                                            });
                                                        }}
                                                        checked={addLocationObj?.isDocumentRequired == 'true' ? true : false}
                                                        type="checkbox"
                                                    />
                                                    <span className={`${styles.slider} ${styles.round}`}></span>
                                                </label>
                                                <span className={styles.OpenCloseText}>ID Verification required for visitors</span>
                                            </div>

                                            {/* Show price for this property */}
                                            <div className={styles.openCloseCheckbox}>
                                                <label className={styles.switch}>
                                                    <input
                                                        name="isPriceListed"
                                                        onChange={(e) => {
                                                            setAddLocationObj({
                                                                ...addLocationObj,
                                                                isPriceListed: e.target.checked.toString(),
                                                            });
                                                        }}
                                                        checked={addLocationObj?.isPriceListed === 'true' ? true : false}
                                                        type="checkbox"
                                                    />
                                                    <span className={`${styles.slider} ${styles.round}`}></span>
                                                </label>
                                                <span className={styles.OpenCloseText}>Display price</span>
                                            </div>

                                            {/* {Error Notification} */}
                                            {((userInfo && userInfo.role === 'super_admin') || canUpdateErrorNotification) && (
                                                <div className={styles.openCloseCheckbox}>
                                                    <label className={styles.switch}>
                                                        <input
                                                            name="errorNotification"
                                                            onChange={(e) => {
                                                                setAddLocationObj({
                                                                    ...addLocationObj,
                                                                    errorNotification: e.target.checked,
                                                                });
                                                            }}
                                                            checked={addLocationObj?.errorNotification}
                                                            type="checkbox"
                                                        />
                                                        <span className={`${styles.slider} ${styles.round}`}></span>
                                                    </label>
                                                    <span className={styles.OpenCloseText}>Error Notification</span>
                                                </div>
                                            )}

                                            {/* Custom Disclaimer */}
                                            <div className={styles.openCloseCheckbox}>
                                                <label className={styles.switch}>
                                                    <input
                                                        name="showCardDisclaimer"
                                                        onChange={(e) => {
                                                            setAddLocationObj({
                                                                ...addLocationObj,
                                                                showCardDisclaimer: e.target.checked.toString(),
                                                            });
                                                        }}
                                                        checked={addLocationObj?.showCardDisclaimer === 'true' ? true : false}
                                                        type="checkbox"
                                                    />
                                                    <span className={`${styles.slider} ${styles.round}`}></span>
                                                </label>
                                                <span className={styles.OpenCloseText}>Show Custom Credit Card Disclaimer</span>
                                            </div>
                                        </div>

                                        {addLocationObj?.showCardDisclaimer.toLowerCase() === 'true' && (
                                            <div className={`${styles.fieldWrapper} ${styles.textAreaWrapper} ${styles.full}`}>
                                                <label>Custom Credit Card Disclaimer</label>
                                                <textarea
                                                    name="custom disclaimer"
                                                    placeholder="Enter Custom Credit Card Disclaimer"
                                                    value={addLocationObj?.customCardDisclaimer || ''}
                                                    className={styles.customTextArea}
                                                    onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
                                                        setAddLocationObj({
                                                            ...addLocationObj,
                                                            customCardDisclaimer: event.target.value,
                                                        })
                                                    }
                                                />
                                            </div>
                                        )}
                                    </form>
                                </div>
                            </TabPanel>

                            {/* Google Location */}
                            <TabPanel>
                                <div className={styles.formWrapper}>
                                    <form onSubmit={submitHandler} id={styles.addLocationForm}>
                                        <div className={styles.locationInfoWrapper}>
                                            <div className={styles.leftContainer}>
                                                <div className={`${styles.fieldWrapper} `}>
                                                    <label>Google Location</label>

                                                    <GoogleAutocompleteInput
                                                        onPlaceChange={(
                                                            lat: number | null,
                                                            long: number | null,
                                                            googlePlacesId: string | null,
                                                        ) => {
                                                            setAddLocationObj({
                                                                ...addLocationObj,
                                                                latitude: Number(lat),
                                                                longitude: Number(long),
                                                                googlePlacesId: googlePlacesId,
                                                            });
                                                        }}
                                                        googlePlacesId={addLocationObj?.googlePlacesId}
                                                    />
                                                </div>

                                                <div className={`${styles.fieldWrapper}`}>
                                                    <label htmlFor="radius">Enter Radius (miles)</label>
                                                    <input
                                                        id="radius"
                                                        type="number"
                                                        name="radius"
                                                        value={addLocationObj?.radius}
                                                        onChange={changeHandler}
                                                        placeholder="Enter radius in miles"
                                                    />
                                                </div>
                                            </div>
                                            <div className={styles.rightContainer}>
                                                <MapView
                                                    latitude={String(addLocationObj?.latitude) || ''}
                                                    longitude={String(addLocationObj?.longitude) || ''}
                                                    radius={addLocationObj?.radius || 0}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </TabPanel>

                            {/* PMS Configuration */}
                            <TabPanel>
                                <div
                                    className={`${styles.pmsConfigurationWrapper} ${styles.formWrapper} ${
                                        !pmsInfoUpdateAccess ? styles.disabled : ''
                                    }`}>
                                    {hasPmsConnected ? (
                                        <div className={styles.configuredPMSWrap}>
                                            <div className={styles.configuredPMSTopBar}>
                                                <h2>Configured PMS/CRM</h2>
                                                <Button type="button" variant="green" onClick={() => handleOpenPmsModal()}>
                                                    Connect PMS/CRM
                                                </Button>
                                            </div>
                                            <div className={styles.pmsGrid}>
                                                {pmsData.map((opt) => (
                                                    <div
                                                        key={opt.key}
                                                        className={styles.pmsCard}
                                                        ref={
                                                            openMenu === opt.key
                                                                ? (el) => {
                                                                      wrapperRef.current = el;
                                                                  }
                                                                : undefined
                                                        }>
                                                        {/* Top Section */}
                                                        <div className={styles.pmsCardHeader}>
                                                            <div className={styles.pmsLogo}>
                                                                {typeof opt.icon === 'string' ? (
                                                                    <img src={opt.icon} alt={opt.label} />
                                                                ) : (
                                                                    opt.icon
                                                                )}
                                                            </div>

                                                            <div className={styles.pmsRight}>
                                                                <div
                                                                    className={`${styles.pmsStatus} ${opt.status === 'active' ? styles.statusActive : styles.statusFailure}`}>
                                                                    <span className={styles.statusPoint}></span>
                                                                    {opt.status === 'active' ? 'Active' : 'Failure'}
                                                                </div>

                                                                {/* 3 Dots */}
                                                                <div
                                                                    className={styles.menuDots}
                                                                    onClick={() => setOpenMenu(openMenu === opt.key ? null : opt.key)}>
                                                                    <span></span>
                                                                    <span></span>
                                                                    <span></span>

                                                                    {/* Dropdown */}
                                                                    {openMenu === opt.key && (
                                                                        <div className={styles.dropdown}>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    handleOpenPmsModal(opt.key);
                                                                                    setOpenMenu(null);
                                                                                }}>
                                                                                Edit
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className={styles.dropdownDelete}
                                                                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                                                                    e.stopPropagation();
                                                                                    setPmsKeyToDelete(opt.key);
                                                                                    setOpenMenu(null);
                                                                                    setShowActionBox(null);
                                                                                    setShowConfirmModal(true);
                                                                                }}>
                                                                                Delete
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Bottom Section */}
                                                        <div className={styles.pmsInfo}>
                                                            <h3>
                                                                {opt.label} {opt.label === 'Knock' ? 'CRM' : 'PMS'}
                                                            </h3>
                                                            <p>Connected on {opt.connectedDate}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={styles.noDataFoundWrap}>
                                            <h2 className={styles.title}>No PMS/CRM Connected Yet</h2>
                                            <p className={styles.description}>
                                                Connect your PMS/CRM to automatically sync property details, units, availability, and
                                                reservations in real time.
                                            </p>
                                            <Button type="button" variant="green" onClick={() => handleOpenPmsModal()}>
                                                Connect PMS/CRM
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            </TabPanel>

                            {/* Office Hours */}
                            <TabPanel>
                                <div className={styles.officeHoursWrapper}>
                                    <h4 className={styles.officeHoursTitle}>
                                        Office Hours <sup className={styles.required}>*</sup>
                                    </h4>

                                    {officeHours?.map(
                                        (data: { day: string; openTime: string; closeTime: string; isOpen: boolean }, index: number) => (
                                            <div key={index} className={styles.setTimeOuter}>
                                                <div className={styles.setTimeWrapper}>
                                                    <p className={styles.week}>{data.day}</p>
                                                    <div className={styles.openCloseCheckbox}>
                                                        <label className={styles.switch}>
                                                            <input
                                                                name="isOpen"
                                                                onChange={() => onChangeHandler(index, data.isOpen)}
                                                                checked={data.isOpen}
                                                                type="checkbox"
                                                            />
                                                            <span className={`${styles.slider} ${styles.round}`}></span>
                                                        </label>
                                                        <span className={styles.OpenCloseText}>{data.isOpen ? 'Open' : 'Closed'}</span>
                                                    </div>
                                                    {data.isOpen && (
                                                        <div className={styles.avilableTimeWrapper}>
                                                            <div style={{ position: 'relative' }}>
                                                                <DatePicker
                                                                    timeCaption="Open Time"
                                                                    onChange={(e) =>
                                                                        officeHoursChangeHandler(e, index, data.isOpen, 'openTime')
                                                                    }
                                                                    minTime={new Date(moment().startOf('day').toISOString())}
                                                                    maxTime={
                                                                        data.closeTime
                                                                            ? new Date(`${moment().format('Y-M-D')} ${data.closeTime}`)
                                                                            : undefined
                                                                    }
                                                                    dateFormat="h:mm aa"
                                                                    showTimeSelectOnly
                                                                    showTimeSelect
                                                                    // value={data.openTime}
                                                                    timeIntervals={30}
                                                                    placeholderText="00:00 AM"
                                                                    name={'openTime'}
                                                                    className={'dateInput'}
                                                                    popperClassName="office-hours-time-popper"
                                                                    selected={
                                                                        data.openTime !== ''
                                                                            ? new Date('2001-01-01T' + data.openTime)
                                                                            : undefined
                                                                    }
                                                                />
                                                            </div>

                                                            <span className={styles.toWrapper}>to</span>
                                                            {/* <div className={`${styles.startTimeWrapper} dateInput`}> */}
                                                            <div style={{ position: 'relative' }}>
                                                                <DatePicker
                                                                    timeCaption="Close Time"
                                                                    onChange={(e) =>
                                                                        officeHoursChangeHandler(e, index, data.isOpen, 'closeTime')
                                                                    }
                                                                    minTime={
                                                                        data.openTime
                                                                            ? new Date(`${moment().format('Y-M-D')} ${data.openTime + 1}`)
                                                                            : undefined
                                                                    }
                                                                    maxTime={new Date(moment().endOf('day').toISOString())}
                                                                    dateFormat="h:mm aa"
                                                                    timeFormat="h:mm aa"
                                                                    showTimeSelect
                                                                    showTimeSelectOnly
                                                                    className={'dateInput'}
                                                                    popperClassName="office-hours-time-popper"
                                                                    // value={data.closeTime}
                                                                    name="closeTime"
                                                                    selected={
                                                                        data.openTime !== ''
                                                                            ? new Date('2001-01-01T' + data.closeTime)
                                                                            : undefined
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ),
                                    )}
                                </div>
                            </TabPanel>

                            {/* Message Template */}
                            <TabPanel>
                                <form id={styles.confirmLocationForm}>
                                    <div className={`${styles.fieldWrapper} ${styles.full}`}>
                                        <label>
                                            Message to potential renter upon scheduling a tour. Consider including a greeting, directions to
                                            parking, and how to locate the entrance and the key kiosk.{' '}
                                            <span className={styles.astrikSign}>*</span>
                                        </label>
                                        <textarea
                                            id="confirmText"
                                            value={addLocationObj.confirmText}
                                            name="confirmText"
                                            placeholder="Add Text"
                                            onChange={changeHandler}
                                            onKeyPress={(e) => handleKeyPress(e, 'confirmText')}
                                        />
                                    </div>

                                    <div className={`${styles.fieldWrapper} ${styles.full}`}>
                                        <label>
                                            Message to potential renter upon beginning a tour. This will be sent to the visitor when they
                                            receive the keys.
                                        </label>
                                        <textarea
                                            id="beginningTourMessage"
                                            value={addLocationObj.beginningTourMessage}
                                            name="beginningTourMessage"
                                            placeholder="Add Start of Tour Message"
                                            onChange={changeHandler}
                                            onKeyPress={(e) => handleKeyPress(e, 'beginningTourMessage')}
                                        />
                                    </div>

                                    <div className={`${styles.fieldWrapper} ${styles.full}`}>
                                        <label>
                                            Message to potential renter upon ending a tour. This will be sent to the visitor when they
                                            return the keys.
                                        </label>
                                        <textarea
                                            id="endingTourMessage"
                                            value={addLocationObj.endingTourMessage}
                                            name="endingTourMessage"
                                            placeholder="Add End of Tour Message"
                                            onChange={changeHandler}
                                            onKeyPress={(e) => handleKeyPress(e, 'endingTourMessage')}
                                        />
                                    </div>

                                    {locationID && (
                                        <ExperienceMessage
                                            setMessage={setMessage}
                                            message={message}
                                            type={locationID?.id ? 'edit' : 'add'}
                                            locationData={locationID && locationID.id}
                                        />
                                    )}
                                </form>
                            </TabPanel>

                            {/* Chatbot Insights */}
                            <TabPanel>
                                <div className={`${styles.formWrapper} ${!chatbotInsightsUpdateAccess ? styles.disabled : ''}`}>
                                    <form onSubmit={submitHandler} id={styles.confirmLocationForm}>
                                        {!excelFile?.file && (
                                            <div
                                                className={`${styles.fileUploadContainer} ${
                                                    !chatbotInsightsUpdateAccess ? styles.disabled : ''
                                                }`}>
                                                <input
                                                    disabled={!chatbotInsightsUpdateAccess}
                                                    id="fileInput"
                                                    name="fileInput"
                                                    className={styles.fileInput}
                                                    type="file"
                                                    accept=".xls, .xlsx, .ods"
                                                    onChange={handleFileUpload}
                                                />
                                                {/* <img src={cloudUploadIcon} alt='cloud-upload-img' width={34} height={34} /> */}
                                                <ExcelIcon fill="#51ab86" />
                                                <p className={styles.primaryText}>
                                                    Drag and Drop file or{' '}
                                                    <span>
                                                        <u>Click to Upload</u>
                                                    </span>
                                                </p>
                                                <p className={styles.primaryText}>Max size: 5 MB | .xls, .xlsx formats allowed</p>
                                            </div>
                                        )}

                                        {!!excelError && <p className={styles.excelError}>{excelError}</p>}

                                        {excelFile?.file && (
                                            <div className={styles.fileContainer}>
                                                <div className={styles.iconContainer}>
                                                    <img src={xlsIcon} alt="excel icon" width={37.08} height={37.08} />
                                                </div>
                                                <div className={styles.fileDetailContainer}>
                                                    <p className={styles.primaryText}>{excelFile?.file?.name}</p>
                                                    <p className={styles.secondaryText}>
                                                        {excelFile?.file ? bytesToMB(excelFile.file.size).toFixed(3) + ' MB' : null}
                                                    </p>

                                                    {
                                                        <div className={`${styles.close}`}>
                                                            <img
                                                                src={iconClose}
                                                                width={15}
                                                                height={15}
                                                                onClick={() => {
                                                                    setExcelFile({ file: null });
                                                                    setAddLocationObj((addLocationObj) => {
                                                                        return {
                                                                            ...addLocationObj,
                                                                            propertyDetailsForBot: '',
                                                                        };
                                                                    });
                                                                }}
                                                                alt="Close"
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        )}

                                        <div className={`${styles.fieldWrapper} ${styles.full}`}>
                                            <div className={styles.inlineItems}>
                                                <label>Enter Insights for Chatbot</label>
                                                {!excelFile?.file && (
                                                    <a
                                                        href={
                                                            'https://account-image-v1.s3.ap-south-1.amazonaws.com/chatbot-insight-excel-sheet/Property_QA_Insight.xlsx'
                                                        }
                                                        download="https://account-image-v1.s3.ap-south-1.amazonaws.com/chatbot-insight-excel-sheet/Property_QA_Insight.xlsx"
                                                        target="_blank"
                                                        rel="noopener noreferrer">
                                                        <button
                                                            type="button"
                                                            className={styles.downloadBtn}
                                                            disabled={userInfo && userInfo.role !== 'super_admin'}>
                                                            Download Template
                                                        </button>
                                                    </a>
                                                )}
                                            </div>

                                            <div
                                                className={`${styles.richTextEditor} custom-rich-text-editor ${
                                                    !chatbotInsightsUpdateAccess ? 'disabled' : ''
                                                }`}>
                                                <ReactQuill
                                                    theme="snow"
                                                    readOnly={!chatbotInsightsUpdateAccess}
                                                    value={addLocationObj?.propertyDetailsForBot || ''}
                                                    modules={{ toolbar: toolbarOptions }}
                                                    // onChange={async (
                                                    //     _value: string,
                                                    //     _delta: DeltaStatic,
                                                    //     _source: Sources,
                                                    //     editor: ReactQuill.UnprivilegedEditor,
                                                    // ) => {
                                                    //     const withoutImage = await removeImageTags(_value);
                                                    //     if (_source === 'user') {
                                                    //         onEditorChange(editor?.getText().trim() !== '' ? withoutImage : null);
                                                    //     }
                                                    // }}
                                                    onChange={async (content, delta, source, editor) => {
                                                        if (source === 'user') {
                                                            const withoutImage = await removeImageTags(content);
                                                            onEditorChange(editor?.getText().trim() !== '' ? withoutImage : null);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </TabPanel>
                        </Tabs>
                    </div>
                    <div className={styles.btnWrapperSave}>
                        <button onClick={submitHandler} type="submit">
                            <span>Save</span>
                        </button>
                    </div>
                </div>
            )}

            <CustModal open={showModal} setOpen={setShowModal} bodyData={<ViewUploadedFile />} className="file-viewer-modal" />
            <CustModal
                open={showLogsModal}
                className="logs-modal"
                setOpen={setShowLogsModal}
                bodyData={<HistoryModalBody data={officeHourData.auditLogs} setShowLogsModal={setShowLogsModal} />}
            />

            <CustModal
                open={showPropertyInformationLogs}
                className="logs-modal"
                setOpen={setShowPropertyInformationLogs}
                bodyData={
                    <PropertyInformationModalBody
                        data={officeHourData.auditLogs}
                        setShowPropertyInformationLogs={setShowPropertyInformationLogs}
                    />
                }
            />

            <CustModal
                open={openModal}
                setOpen={setOpenModal}
                shouldCloseOnOverLay={false}
                bodyData={
                    <PMSConfiguaration
                        setOpen={setOpenModal}
                        onSave={handlePmsConfigSave}
                        locationId={locationID.id}
                        editPmsKey={editingPmsKey as 'yardi' | 'entrata' | 'realpage' | 'resman' | 'knock' | 'funnel' | null}
                        editFormData={getEditFormData && editingPmsKey ? (getEditFormData as unknown as Record<string, Record<string, string>>)[editingPmsKey] ?? null : null}
                        connectedPmsKeys={[
                            ...connectedPmsList.map((p: { pms_key: string }) => p.pms_key),
                            ...pendingPmsList.map((p) => p.pmsType),
                            ...newlyConnectedPmsEdit.map((p) => p.pmsType),
                        ]}
                    />
                }
            />

            {showConfirmModal && (
                <CustModal
                    open={showConfirmModal}
                    setOpen={setShowConfirmModal}
                    bodyData={<ActionModalBody />}
                    onCloseModal={() => {
                        setShowConfirmModal(false);
                        setPmsKeyToDelete(null);
                    }}
                />
            )}
        </>
    );
};

export default AddProperty;
